import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';

export const AgyleLogoIcon = (props) => {
	return (
	<SvgIcon {...props} viewBox="0 0 581 581" fill="dodgerblue">
		<g className={"agyle-menu"}>
			<circle style={{fill: "#2180F7"}} cx="290.6" cy="290.6" r="290.6"/>
			<g className={"agyle-menu"}>
				<path style={{fill: "#FFFFFF"}} d="M453.6,292.5h-0.9h-15.9h-56.9v-73.4c0-13.1-10.6-23.7-23.7-23.7c-13.1,0-23.7,10.6-23.7,23.7v73.4h-40.5
			h-2.5c-5.9,0-13.7,4.8-17.5,10.6l-17,26.1c-3.8,5.9-2.1,10.6,3.7,10.6h0.9h15.9h56.9v73.4c0,13.1,10.6,23.7,23.7,23.7
			c13.1,0,23.7-10.6,23.7-23.7v-73.4h40.5h2.5c5.9,0,13.7-4.8,17.5-10.6l17-26.1C461.1,297.3,459.5,292.5,453.6,292.5z"/>
				<path style={{fill: "#FFFFFF"}} d="M356.3,161.2c13.1,0,23.7-10.6,23.7-23.7c0-13.1-10.6-23.7-23.7-23.7h-36.9c-7.8,0-15,3.8-19.5,10.2
			L108.8,399.8c-7.5,10.7-4.8,25.5,6,32.9c4.1,2.9,8.8,4.2,13.5,4.2c7.5,0,14.9-3.6,19.5-10.2l184-265.5H356.3z"/>
			</g>
		</g>
	</SvgIcon>
	)
}

export const VitalPacLogoIcon = (props) => {
	return (
		<SvgIcon {...props} viewBox="0 0 80 80">
			<g id="agyle-logo-link">
				<rect id="Rectangle 2193" width="80" height="80" rx="8" fill="url(#pattern0)"/>
			</g>
			<defs>
				<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
					<use href="#image0_2028_25146" transform="scale(0.00390625)"/>
				</pattern>
				<image id="image0_2028_25146" data-name="image.png" width="256" height="256" href="data:image/png;base64,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"/>
			</defs>
		</SvgIcon>

	)
}

export const AgyleLogoBlackIcon = (props) => {
	return (
		<SvgIcon {...props} viewBox="0 0 581 581" fill="dodgerblue">
			<g>
				<path d="M290.6,0C130.1,0,0,130.1,0,290.6s130.1,290.6,290.6,290.6c160.5,0,290.6-130.1,290.6-290.6S451,0,290.6,0z M128.3,436.9
	c-4.7,0-9.4-1.4-13.5-4.2c-10.7-7.4-13.4-22.2-6-32.9l191.1-275.7c4.4-6.4,11.7-10.2,19.5-10.2h36.9c13.1,0,23.7,10.6,23.7,23.7
	c0,13.1-10.6,23.7-23.7,23.7h-24.5l-184,265.5C143.2,433.4,135.8,436.9,128.3,436.9z M457.3,303.2l-17,26.1
	c-3.8,5.9-11.7,10.6-17.5,10.6h-2.5h-40.5v73.4c0,13.1-10.6,23.7-23.7,23.7s-23.7-10.6-23.7-23.7v-73.4h-56.9h-15.9h-0.9
	c-5.9,0-7.5-4.8-3.7-10.6l17-26.1c3.8-5.9,11.7-10.6,17.5-10.6h2.5h40.5v-73.4c0-13.1,10.6-23.7,23.7-23.7s23.7,10.6,23.7,23.7v73.4
	h56.9h15.9h0.9C459.5,292.5,461.1,297.3,457.3,303.2z"/>
			</g>
		</SvgIcon>
	)
}

export const ViewMenuIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<circle fill="none" cx="6.5" cy="16.557" r="3" />
				<circle fill="none" cx="17.5" cy="16.557" r="3" />
				<path
					d="M21.916,15.724l-2.422-7.229c-0.024-1.376-0.847-2.552-2.021-3.103C17.485,5.299,17.5,5.205,17.5,5.106
                        c0-1.194-0.895-2.163-2-2.163c-1.104,0-2,0.969-2,2.163c0,0.297,0.056,0.579,0.156,0.837c0.166-0.131-0.247,0.221-0.522,0.613
                        h-2.267c-0.274-0.393-0.688-0.743-0.523-0.613c0.101-0.258,0.156-0.54,0.156-0.837c0-1.194-0.895-2.163-2-2.163
                        c-1.104,0-2,0.969-2,2.163c0,0.099,0.014,0.192,0.027,0.287C5.354,5.943,4.53,7.118,4.506,8.495l-2.422,7.229
                        C2.033,15.994,2,16.271,2,16.557c0,2.483,2.015,4.5,4.5,4.5s4.5-2.017,4.5-4.5c0,0,0-0.121,0-0.188c0-0.553,0.447-1,1-1
                        s1,0.447,1,1c0,0.066,0,0.188,0,0.188c0,2.483,2.015,4.5,4.5,4.5s4.5-2.017,4.5-4.5C22,16.271,21.967,15.994,21.916,15.724z
                         M6.5,19.557c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S8.154,19.557,6.5,19.557z M13,11.369h-2v-2h2V11.369z M17.5,19.557
                        c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S19.154,19.557,17.5,19.557z"
				/>
			</g>
		</SvgIcon>
	);
};

export const EnhanceMenuIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<circle fill="none" cx="8" cy="19" r="1" />
				<circle fill="none" cx="16" cy="12" r="1" />
				<circle fill="none" cx="8" cy="5" r="1" />
				<path
					d="M10.816,4C10.401,2.838,9.302,2,8,2S5.599,2.838,5.184,4H2v2h3.185C5.599,7.162,6.698,8,8,8s2.401-0.838,2.816-2H22V4
		                H10.816z M8,6C7.449,6,7,5.551,7,5s0.449-1,1-1s1,0.449,1,1S8.551,6,8,6z"
				/>
				<path
					d="M8,16c-1.302,0-2.401,0.839-2.816,2H2v2h3.185C5.599,21.161,6.698,22,8,22s2.401-0.839,2.816-2H22v-2H10.816
		                C10.401,16.839,9.302,16,8,16z M8,20c-0.551,0-1-0.448-1-1s0.449-1,1-1s1,0.448,1,1S8.551,20,8,20z"
				/>
				<path
					d="M16,9c-1.302,0-2.401,0.838-2.815,2H2v2h11.185c0.414,1.161,1.514,2,2.815,2s2.401-0.839,2.815-2H22v-2h-3.185
		                C18.401,9.838,17.302,9,16,9z M16,13c-0.552,0-1-0.449-1-1s0.448-1,1-1s1,0.449,1,1S16.552,13,16,13z"
				/>
			</g>
		</SvgIcon>
	);
};

export const MeasurementMenuIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path fill="none" d="M19.999,5.414L5.413,20h14.586V5.414z M17.499,17.5h-5.707l5.707-5.707V17.5z" />
				<path
					d="M2.075,21.383C2.229,21.757,2.595,22,2.999,22h18c0.552,0,1-0.447,1-1V3c0-0.404-0.244-0.769-0.617-0.924
		                c-0.373-0.156-0.803-0.07-1.09,0.217l-18,18C2.006,20.579,1.92,21.009,2.075,21.383z M5.413,20L19.999,5.414V20H5.413z"
				/>
				<polygon points="11.792,17.5 17.499,17.5 17.499,11.793 	" />
			</g>
		</SvgIcon>
	);
};

export const DrawingMenuIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path
					fill="none"
					d="M19.708,4.293c-0.377-0.377-1.038-0.377-1.415,0l-9.686,9.685l-0.354,1.769l1.769-0.354l9.685-9.685
		                            C20.097,5.318,20.098,4.683,19.708,4.293z"
				/>
				<rect x="2" y="20" width="20" height="2" />
				<path
					d="M21.123,7.121c1.167-1.169,1.168-3.072,0-4.242c-1.136-1.133-3.11-1.133-4.244,0L6.765,12.992l-1.06,5.304l5.304-1.061
		                L21.123,7.121z M8.253,15.747l0.354-1.769l9.686-9.685c0.377-0.378,1.038-0.377,1.415,0c0.39,0.39,0.389,1.025-0.001,1.416
		                l-9.685,9.685L8.253,15.747z"
				/>
			</g>
		</SvgIcon>
	);
};

export const StudyListMenuIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<rect x="2" y="4" width="4" height="4" />
				<rect x="8" y="4" width="14" height="4" />
				<rect x="2" y="10" width="4" height="4" />
				<rect x="8" y="10" width="14" height="4" />
				<rect x="2" y="16" width="4" height="4" />
				<rect x="8" y="16" width="14" height="4" />
			</g>
		</SvgIcon>
	);
};
export const XupGridIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<rect x="2" y="2" width="9" height="9"/>
				<path d="M13,2v9h9V2H13z M20,9h-5V4h5V9z"/>
				<path d="M2,22h9v-9H2V22z M4,15h5v5H4V15z"/>
				<path d="M13,22h9v-9h-9V22z M15,15h5v5h-5V15z"/>
			</g>
		</SvgIcon>
	);
};

export const SwitchEyonixIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<defs>
					<rect id="SVGID_1_" x="-947.999" y="-369.177" width="2000" height="2500"/>
				</defs>

			</g>
			<g>
				<defs>
					<rect id="SVGID_3_" x="-947.999" y="-369.177" width="2000" height="2500"/>
				</defs>

			</g>
			<g>
				<path d="M4,12c0-2.784,1.601-5.203,4-6.329V8h2V2H4v2h2.873C3.94,5.5,2,8.528,2,12c0,4.963,4.038,9,9,9v-2C7.14,19,4,15.859,4,12z"/>
				<path d="M22,12c0-4.962-4.037-9-9-9v2c3.859,0,7,3.14,7,7c0,2.783-1.601,5.202-4,6.329V16h-2v6h6v-2h-2.873   C20.06,18.499,22,15.472,22,12z"/>
			</g>
		</SvgIcon>
	);
};

export const RelatedEyonixIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<path d="M17.5,15c-0.9,0-1.7,0.4-2.4,0.9l-5.2-3.1C10,12.6,10,12.3,10,12s0-0.6-0.1-0.8l5.2-3.1C15.8,8.6,16.6,9,17.5,9  C19.4,9,21,7.4,21,5.5S19.4,2,17.5,2S14,3.6,14,5.5c0,0.3,0,0.6,0.1,0.8L8.9,9.4C8.2,8.9,7.4,8.5,6.5,8.5C4.6,8.5,3,10.1,3,12  s1.6,3.5,3.5,3.5c0.9,0,1.7-0.4,2.4-0.9l5.2,3.1C14,17.9,14,18.2,14,18.5c0,1.9,1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5S19.4,15,17.5,15z"/>
		</SvgIcon>
	);
};

export const SplitMenuIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path d="M19.776,3.221h-5v2h4v13.555h-4v2h5c0.553,0,1-0.447,1-1V4.221C20.776,3.669,20.329,3.221,19.776,3.221z" />
				<path d="M3.222,4.221v15.555c0,0.553,0.448,1,1,1h5v-2h-4V5.221h4v-2h-5C3.669,3.221,3.222,3.669,3.222,4.221z" />
				<rect x="11" y="19.001" width="1.999" height="3" />
				<rect x="11" y="7" width="1.999" height="4" />
				<rect x="11" y="13.001" width="1.999" height="4" />
				<rect x="11" y="2" width="1.999" height="3" />
			</g>
		</SvgIcon>
	);
};

export const InfoMenuIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path
					d="M12.97,8.4c0.299-0.28,0.459-0.61,0.459-1.01c0-0.39-0.16-0.73-0.459-1.01c-0.3-0.29-0.66-0.43-1.08-0.43
                        c-0.43,0-0.79,0.14-1.09,0.43C10.49,6.66,10.34,7,10.34,7.39c0,0.4,0.15,0.73,0.46,1.01c0.3,0.28,0.66,0.42,1.09,0.42
                        C12.3,8.82,12.66,8.68,12.97,8.4z M13.26,10.2l-3.83,0.21v0.57c0.16,0.01,0.33,0.05,0.52,0.11c0.19,0.05,0.34,0.11,0.43,0.18
                        c0.12,0.08,0.23,0.19,0.31,0.33s0.13,0.3,0.13,0.48v4.54c0,0.2-0.04,0.35-0.11,0.47c-0.06,0.12-0.18,0.21-0.35,0.271
                        c-0.09,0.04-0.2,0.06-0.33,0.08c-0.13,0.01-0.27,0.029-0.4,0.04v0.569h4.94V17.48C14.43,17.46,14.3,17.44,14.18,17.4
                        c-0.13-0.04-0.239-0.08-0.35-0.131c-0.14-0.06-0.26-0.149-0.33-0.279c-0.08-0.13-0.12-0.28-0.12-0.471v-6.2L13.26,10.2z M12,2
                        c5.52,0,10,4.48,10,10c0,5.52-4.48,10-10,10C6.48,22,2,17.52,2,12C2,6.48,6.48,2,12,2z"
				/>
			</g>
		</SvgIcon>
	);
};

export const View1x1Icon = (props) => {
	return (
		<SvgIcon {...props}>
			<rect x="2" y="2" width="20" height="20" />
		</SvgIcon>
	);
};
export const View2x2Icon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<rect x="2" y="2" width="9" height="9" />
				<rect x="13" y="2" width="9" height="9" />
				<rect x="2" y="13" width="9" height="9" />
				<rect x="13" y="13" width="9" height="9" />
			</g>
		</SvgIcon>
	);
};
export const View3x3Icon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<rect x="2" y="2" width="6" height="6" />
				<rect x="16" y="2" width="6" height="6" />
				<rect x="9" y="2" width="6" height="6" />
				<rect x="2" y="9" width="6" height="6" />
				<rect x="16" y="9" width="6" height="6" />
				<rect x="9" y="9" width="6" height="6" />
				<rect x="2" y="16" width="6" height="6" />
				<rect x="16" y="16" width="6" height="6" />
				<rect x="9" y="16" width="6" height="6" />
			</g>
		</SvgIcon>
	);
};
export const View4x4Icon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<rect x="18" y="2" width="4" height="4" />
				<rect x="18" y="18" width="4" height="4" />
				<rect x="18" y="12.667" width="4" height="4" />
				<rect x="18" y="7.334" width="4" height="4" />
				<rect x="2" y="2" width="4" height="4" />
				<rect x="2" y="18" width="4" height="4" />
				<rect x="2" y="12.667" width="4" height="4" />
				<rect x="2" y="7.334" width="4" height="4" />
				<rect x="7.333" y="2" width="4" height="4" />
				<rect x="7.333" y="18" width="4" height="4" />
				<rect x="7.333" y="12.667" width="4" height="4" />
				<rect x="7.333" y="7.334" width="4" height="4" />
				<rect x="12.666" y="2" width="4" height="4" />
				<rect x="12.666" y="18" width="4" height="4" />
				<rect x="12.666" y="12.667" width="4" height="4" />
				<rect x="12.666" y="7.334" width="4" height="4" />
			</g>
		</SvgIcon>
	);
};
export const View6x6Icon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<rect x="2" y="2" width="2" height="2" />
				<rect x="2" y="20" width="2" height="2" />
				<rect x="2" y="16.4" width="2" height="2" />
				<rect x="2" y="12.8" width="2" height="2" />
				<rect x="2" y="9.2" width="2" height="2" />
				<rect x="2" y="5.6" width="2" height="2" />
				<rect x="5.6" y="2" width="2" height="2" />
				<rect x="5.6" y="20" width="2" height="2" />
				<rect x="5.6" y="16.4" width="2" height="2" />
				<rect x="5.6" y="12.8" width="2" height="2" />
				<rect x="5.6" y="9.2" width="2" height="2" />
				<rect x="5.6" y="5.6" width="2" height="2" />
				<rect x="9.2" y="2" width="2" height="2" />
				<rect x="9.2" y="20" width="2" height="2" />
				<rect x="9.2" y="16.4" width="2" height="2" />
				<rect x="9.2" y="12.8" width="2" height="2" />
				<rect x="9.2" y="9.2" width="2" height="2" />
				<rect x="9.2" y="5.6" width="2" height="2" />
				<rect x="12.8" y="2" width="2" height="2" />
				<rect x="12.8" y="20" width="2" height="2" />
				<rect x="12.8" y="16.4" width="2" height="2" />
				<rect x="12.8" y="12.8" width="2" height="2" />
				<rect x="12.8" y="9.2" width="2" height="2" />
				<rect x="12.8" y="5.6" width="2" height="2" />
				<rect x="16.4" y="2" width="2" height="2" />
				<rect x="16.4" y="20" width="2" height="2" />
				<rect x="16.4" y="16.4" width="2" height="2" />
				<rect x="16.4" y="12.8" width="2" height="2" />
				<rect x="16.4" y="9.2" width="2" height="2" />
				<rect x="16.4" y="5.6" width="2" height="2" />
				<rect x="20" y="2" width="2" height="2" />
				<rect x="20" y="20" width="2" height="2" />
				<rect x="20" y="16.4" width="2" height="2" />
				<rect x="20" y="12.8" width="2" height="2" />
				<rect x="20" y="9.2" width="2" height="2" />
				<rect x="20" y="5.6" width="2" height="2" />
			</g>
		</SvgIcon>
	);
};

export const BackIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<polygon points="17,6.015 15.693,4.5 7,12 15.693,19.5 17,17.986 10.062,12 " />
		</SvgIcon>
	);
};

export const AKAIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path
					d="M21,5H3C2.448,5,2,5.448,2,6v12c0,0.553,0.448,1,1,1h18c0.553,0,1-0.447,1-1V6C22,5.448,21.553,5,21,5z M7.118,14.506
		l-0.25-0.828H5.11l-0.244,0.828H3.285l1.883-5.012h1.689l1.883,5.012H7.118z M12.994,14.506l-1.057-2.062l-0.8,0.839v1.223H9.589
		V9.494h1.549v1.894l1.622-1.894h2.059l-1.828,1.892l1.91,3.12H12.994z M19.094,14.506l-0.25-0.828h-1.758l-0.244,0.828H15.26
		l1.885-5.012h1.688l1.883,5.012H19.094z"
				/>
				<polygon points="17.422,12.595 18.521,12.595 17.969,10.793 	" />
				<polygon points="5.446,12.595 6.547,12.595 5.993,10.793 	" />
			</g>
		</SvgIcon>
	);
};
export const AlertIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<path d="M12,3L2,21h20L12,3z M12.92,19h-1.85v-1.92h1.85V19z M12.53,15.86h-1.05L11,11.35V9h2v2.35L12.53,15.86z" />
		</SvgIcon>
	);
};
export const IDAIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path
					d="M21.94,12.35c-0.011-0.416-0.02-0.724-0.02-0.85c0-5.061-4.639-9.5-9.928-9.5s-9.928,4.439-9.928,9.5
		c0,0.097-0.006,0.357-0.014,0.724c-0.034,1.559-0.105,4.804,0.019,5.863c0.163,1.4,1.625,3.552,3.635,3.871
		c0.409,0.065,0.794-0.215,0.858-0.623c0.064-0.41-0.215-0.794-0.623-0.859c-1.295-0.205-2.291-1.798-2.38-2.562
		c-0.112-0.957-0.04-4.251-0.01-5.657c0.009-0.382,0.015-0.655,0.015-0.756c0-4.187,4.017-8,8.428-8s8.428,3.813,8.428,8
		c0,0.132,0.009,0.453,0.02,0.889c0.039,1.487,0.119,4.583-0.012,5.507c-0.114,0.81-1.268,2.433-2.607,2.611
		c-0.411,0.055-0.699,0.432-0.645,0.842C17.227,21.726,17.549,22,17.919,22c0.033,0,0.066-0.002,0.1-0.007
		c2.082-0.277,3.698-2.488,3.896-3.889C22.062,17.058,21.983,13.995,21.94,12.35z"
				/>
				<circle cx="15.251" cy="12.999" r="1" />
				<circle cx="8.749" cy="13" r="1" />
				<path
					d="M13.75,15c0-0.276-0.224-0.5-0.5-0.5s-0.5,0.224-0.5,0.5c0,0.267-0.351,0.5-0.75,0.5s-0.75-0.233-0.75-0.5
		c0-0.276-0.224-0.5-0.5-0.5s-0.5,0.224-0.5,0.5c0,0.827,0.785,1.5,1.75,1.5S13.75,15.827,13.75,15z"
				/>
				<path
					d="M18.75,14.678v-2.094c0-2.316-1.801-4.202-4.015-4.202h-3.515c-0.001,0-0.001,0-0.001,0c-1.436,0-1.963-0.564-2.018-2.157
		C9.188,5.811,8.837,5.473,8.429,5.501C8.015,5.515,7.69,5.861,7.704,6.275c0.08,2.393,1.264,3.606,3.516,3.606c0,0,0,0,0.002,0
		h3.514c1.387,0,2.515,1.212,2.515,2.702v2.094c0,1.604-1.245,3.178-2.515,3.178h-0.99l-2.914,1.438v-1.438H9.265
		c-1.27,0-2.515-1.573-2.515-3.178v-2.089c0-0.011,0.021-1.06,0.692-1.854c0.268-0.316,0.229-0.789-0.088-1.057
		c-0.316-0.269-0.79-0.229-1.058,0.088C5.262,10.99,5.25,12.52,5.25,12.584v2.094c0,2.208,1.717,4.677,4.015,4.677h0.066v2.352
		l4.764-2.352h0.641C17.033,19.354,18.75,16.886,18.75,14.678z"
				/>
			</g>
		</SvgIcon>
	);
};
export const NewDocumentIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g id="Layer_5">
				<path
					d="M20,2H8C7.7,2,7.5,2.1,7.3,2.3l-4,4C3.1,6.5,3,6.7,3,7v14c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V3C21,2.4,20.6,2,20,2z
		 M5,11.9h1.1l1.5,2.4v-2.4h1.1v4.3H7.6l-1.5-2.4v2.4H5V11.9z M19,20H5v-2h14V20z M12.8,13.5v0.9H11v0.8h2.1v1H9.8v-4.3H13v0.9h-2
		v0.7H12.8z M18.1,16.1H17l-0.7-2.7l-0.7,2.7h-1.2l-0.9-4.3h1.1l0.4,2.4l0.6-2.4h1.1l0.6,2.4l0.4-2.4H19L18.1,16.1z M19,10H5V8h3
		c0.6,0,1-0.4,1-1V4h10V10z"
				/>
			</g>
		</SvgIcon>
	);
};
// export const HistoryIcon = props => {
//     return (
//         <SvgIcon {...props}>
//             <g>
//                 <path d="M10.947,6.509c-0.582,0-1.053,0.471-1.053,1.052v6.085l5.009,1.251c0.085,0.021,0.17,0.032,0.256,0.032
// 		c0.472,0,0.9-0.318,1.021-0.798c0.14-0.563-0.202-1.135-0.767-1.276L12,12.002V7.561C12,6.98,11.529,6.509,10.947,6.509z"/>
//                 <path d="M12,2.002c-2.689,0-5.201,1.058-7.067,2.931L3.579,3.579v4.21h4.21L6.347,6.347C7.84,4.848,9.849,4.002,12,4.002
// 		c4.411,0,8,3.589,8,8s-3.589,8-8,8s-8-3.589-8-8H2c0,5.514,4.486,10,10,10c5.514,0,10-4.486,10-10C22,6.488,17.514,2.002,12,2.002z
// 		"/>
//             </g>
//         </SvgIcon>
//     );
// };
export const UploadIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path d="M11,5.4V16h2V5.4l2.8,2.8l1.4-1.4l-4.5-4.5C12.5,2.1,12.3,2,12,2s-0.5,0.1-0.7,0.3L6.8,6.8l1.4,1.4L11,5.4z" />
				<path d="M20,11v9H4v-9H2v10c0,0.6,0.4,1,1,1h18c0.6,0,1-0.4,1-1V11H20z" />
			</g>
		</SvgIcon>
	);
};
// export const TrashIcon = props => {
//     return (
//         <SvgIcon {...props}>
//             <g>
//                 <rect x="14" y="8" width="2" height="10" />
//                 <rect x="11" y="8" width="2" height="10" />
//                 <rect x="8" y="8" width="2" height="10" />
//                 <path d="M15.86,22H8.14C6.41,22,5,20.43,5,18.5V6H4V4h6V2h4v2h6v2h-1v12.5C19,20.43,17.59,22,15.86,22z M8.14,20h7.72
// 			c0.62,0,1.14-0.69,1.14-1.5V6H7v12.5C7,19.31,7.53,20,8.14,20z"/>
//             </g>
//         </SvgIcon>
//     );
// };
export const PatientListIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path d="M15.289,13.819C17.253,15.438,18.4,17.938,18.4,21H22C22,16.746,19.42,14.02,15.289,13.819z" />
				<path
					d="M14.8,12.6c2.649,0,4.802-2.151,4.802-4.8S17.449,3,14.8,3c-0.247,0-0.483,0.037-0.721,0.073
		c1.188,1.225,1.923,2.891,1.923,4.727s-0.735,3.502-1.923,4.727C14.316,12.563,14.553,12.6,14.8,12.6z"
				/>
				<path d="M9.2,13.8C4.781,13.8,2,16.579,2,21h5.6H16.4C16.4,16.579,13.619,13.8,9.2,13.8z" />
				<path d="M9.2,12.6c2.649,0,4.802-2.151,4.802-4.8S11.849,3,9.2,3C6.546,3,4.4,5.151,4.4,7.8S6.546,12.6,9.2,12.6z" />
			</g>
		</SvgIcon>
	);
};
export const PatientDemographicsIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path d="M55.333-143c-2.454,0-4,1.544-4,4h8C59.333-141.456,57.787-143,55.333-143z" />
				<circle cx="55.333" cy="-146.333" r="2.667" />
				<rect x="39.333" y="-159.594" width="20" height="3" />
				<rect x="39.333" y="-153.594" width="20" height="3" />
				<rect x="39.333" y="-147.594" width="10" height="3" />
			</g>
			<g>
				<path d="M18,18c-2.454,0-4,1.544-4,4h8C22,19.544,20.454,18,18,18z" />
				<circle cx="18" cy="14.667" r="2.667" />
				<rect x="2" y="1.906" width="20" height="2" />
				<rect x="2" y="6.906" width="20" height="2" />
				<rect x="2" y="11.906" width="10" height="2" />
			</g>
		</SvgIcon>
	);
};
export const ActualSizeViewIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<polygon points="4,8.524 4,10.101 6.312,9.383 6.312,16.849 8.25,16.849 8.25,7.077 8.042,7.077 	" />
				<path
					d="M13.487,9.667c-0.095-0.09-0.212-0.164-0.348-0.216c-0.137-0.054-0.287-0.082-0.452-0.082
		c-0.164,0-0.313,0.028-0.446,0.082c-0.137,0.052-0.25,0.126-0.349,0.216c-0.095,0.093-0.167,0.202-0.221,0.328
		c-0.052,0.129-0.077,0.266-0.077,0.414c0,0.147,0.025,0.282,0.077,0.41c0.054,0.125,0.126,0.231,0.221,0.323
		c0.099,0.093,0.212,0.164,0.349,0.216c0.133,0.051,0.282,0.078,0.446,0.078c0.165,0,0.315-0.027,0.452-0.078
		c0.136-0.052,0.253-0.123,0.348-0.216c0.098-0.092,0.171-0.199,0.223-0.323c0.051-0.128,0.079-0.263,0.079-0.41
		c0-0.148-0.028-0.285-0.079-0.414C13.658,9.868,13.585,9.759,13.487,9.667z"
				/>
				<path
					d="M13.487,15.156c-0.095-0.092-0.212-0.162-0.348-0.218c-0.137-0.052-0.287-0.08-0.452-0.08c-0.164,0-0.313,0.028-0.446,0.08
		c-0.137,0.056-0.25,0.126-0.349,0.218c-0.095,0.094-0.167,0.201-0.221,0.329c-0.052,0.126-0.077,0.266-0.077,0.415
		c0,0.146,0.025,0.281,0.077,0.407c0.054,0.126,0.126,0.229,0.221,0.321c0.099,0.095,0.212,0.166,0.349,0.216
		c0.133,0.056,0.282,0.078,0.446,0.078c0.165,0,0.315-0.022,0.452-0.078c0.136-0.05,0.253-0.121,0.348-0.216
		c0.098-0.092,0.171-0.195,0.223-0.321c0.051-0.126,0.079-0.261,0.079-0.407c0-0.149-0.028-0.289-0.079-0.415
		C13.658,15.357,13.585,15.25,13.487,15.156z"
				/>
				<polygon points="19.793,7.077 15.75,8.524 15.75,10.101 18.062,9.383 18.062,16.849 20,16.849 20,7.077 	" />
			</g>
		</SvgIcon>
	);
};
export const FlyingZoomIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path
					fill="none"
					d="M14,4H4v8h4.584c0.208-1.356,0.831-2.608,1.82-3.597c0.987-0.988,2.24-1.612,3.596-1.82V4z"
				/>
				<path
					fill="none"
					d="M14.999,8.5c-1.202,0-2.332,0.468-3.181,1.317c-0.851,0.851-1.319,1.981-1.318,3.184
		c0,1.203,0.469,2.333,1.319,3.183c0.848,0.849,1.977,1.316,3.177,1.316c1.203,0,2.334-0.469,3.186-1.32
		c0.85-0.85,1.318-1.979,1.318-3.181c0.001-1.201-0.467-2.331-1.316-3.179C17.333,8.968,16.202,8.5,14.999,8.5z M18,14h-2.001v2h-2
		v-2h-2v-2h2v-2h2v2H18V14z"
				/>
				<path
					d="M19.598,8.405C18.609,7.416,17.356,6.792,16,6.584V2H2v12h6.584c0.156,1.018,0.549,1.973,1.153,2.805l-0.049,0.05
		l-3.135,3.135l-0.305,0.305c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293
		l0.305-0.305l3.135-3.135l0.043-0.043c1.11,0.823,2.444,1.274,3.852,1.274c1.737,0,3.37-0.677,4.6-1.906
		C20.823,16.367,21.5,14.735,21.5,13C21.501,11.263,20.825,9.631,19.598,8.405z M8.584,12H4V4h10v2.583
		c-1.356,0.208-2.609,0.832-3.596,1.82C9.415,9.392,8.792,10.644,8.584,12z M18.182,16.18c-0.852,0.852-1.982,1.32-3.186,1.32
		c-1.2,0-2.329-0.468-3.177-1.316c-0.85-0.85-1.319-1.979-1.319-3.183c0-1.202,0.468-2.333,1.318-3.184
		c0.849-0.85,1.979-1.317,3.181-1.317c1.203,0,2.334,0.468,3.185,1.319c0.85,0.849,1.317,1.978,1.316,3.179
		C19.5,14.2,19.031,15.33,18.182,16.18z"
				/>
				<polygon
					points="15.999,10 13.999,10 13.999,12 11.999,12 11.999,14 13.999,14 13.999,16 15.999,16 15.999,14 18,14 18,12
		15.999,12 	"
				/>
			</g>
		</SvgIcon>
	);
};
export const FullHeightIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path
					d="M20,2h-3c-0.553,0-1,0.448-1,1s0.447,1,1,1h2v16h-2c-0.553,0-1,0.447-1,1s0.447,1,1,1h3c0.553,0,1-0.447,1-1V3
		C21,2.448,20.553,2,20,2z"
				/>
				<path
					d="M7,20H5V4h2c0.552,0,1-0.448,1-1S7.552,2,7,2H4C3.448,2,3,2.448,3,3v18c0,0.553,0.448,1,1,1h3c0.552,0,1-0.447,1-1
		S7.552,20,7,20z"
				/>
				<path
					d="M15.707,17.293c-0.391-0.391-1.023-0.391-1.414,0L13,18.586V5.414l1.293,1.293C14.488,6.902,14.744,7,15,7
		s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414l-3-3c-0.391-0.391-1.023-0.391-1.414,0l-3,3
		c-0.391,0.391-0.391,1.023,0,1.414s1.023,0.391,1.414,0L11,5.414v13.172l-1.293-1.293c-0.391-0.391-1.023-0.391-1.414,0
		s-0.391,1.023,0,1.414l3,3C11.488,21.902,11.744,22,12,22s0.512-0.098,0.707-0.293l3-3C16.098,18.316,16.098,17.684,15.707,17.293z
		"
				/>
			</g>
		</SvgIcon>
	);
};
export const SwitchIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path d="M4,12c0-2.784,1.601-5.203,4-6.329V8h2V2H4v2h2.873C3.94,5.5,2,8.528,2,12c0,4.963,4.038,9,9,9v-2C7.14,19,4,15.859,4,12z" />
				<path
					d="M22,12c0-4.962-4.037-9-9-9v2c3.859,0,7,3.14,7,7c0,2.783-1.601,5.202-4,6.329V16h-2v6h6v-2h-2.873
		C20.06,18.499,22,15.472,22,12z"
				/>
			</g>
		</SvgIcon>
	);
};
export const FullScreenIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<polygon points="15,2 15,4 18.585,4 13.998,8.586 15.412,10 20,5.413 20,9 22,9 22,2 	" />
				<polygon points="8.588,14 4,18.588 4,15 2,15 2,22 9,22 9,20 5.416,20 10.002,15.414 	" />
			</g>
		</SvgIcon>
	);
};
export const FullWidthIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path
					d="M21,3H3C2.448,3,2,3.448,2,4v3c0,0.552,0.448,1,1,1s1-0.448,1-1V5h16v2c0,0.552,0.447,1,1,1s1-0.448,1-1V4
		C22,3.448,21.553,3,21,3z"
				/>
				<path
					d="M21,16c-0.553,0-1,0.447-1,1v2H4v-2c0-0.553-0.448-1-1-1s-1,0.447-1,1v3c0,0.553,0.448,1,1,1h18c0.553,0,1-0.447,1-1v-3
		C22,16.447,21.553,16,21,16z"
				/>
				<path
					d="M18.707,8.293c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L18.586,11H5.414l1.293-1.293
		c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0l-3,3c-0.391,0.391-0.391,1.023,0,1.414l3,3C5.488,15.902,5.744,16,6,16
		s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L5.414,13h13.172l-1.293,1.293c-0.391,0.391-0.391,1.023,0,1.414
		C17.488,15.902,17.744,16,18,16s0.512-0.098,0.707-0.293l3-3c0.391-0.391,0.391-1.023,0-1.414L18.707,8.293z"
				/>
			</g>
		</SvgIcon>
	);
};
export const PanIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<circle fill="none" cx="12" cy="12" r="2" />
				<path
					d="M12,8c-2.21,0-4,1.79-4,4c0,2.209,1.79,4,4,4c2.209,0,4-1.791,4-4C16,9.79,14.209,8,12,8z M12,14c-1.103,0-2-0.897-2-2
		c0-1.103,0.897-2,2-2c1.103,0,2,0.897,2,2C14,13.103,13.103,14,12,14z"
				/>
				<polygon points="6,16 6,8 2,12 	" />
				<polygon points="18,8 18,16 22,12 	" />
				<polygon points="8,6 16,6 12,2 	" />
				<polygon points="12,22 16,18 8,18 	" />
			</g>
		</SvgIcon>
	);
};
export const ZoomIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path
					fill="none"
					d="M14,4c-3.309,0-6,2.691-6,6s2.691,6,6,6s6-2.691,6-6S17.309,4,14,4z M18,11h-3v3h-2v-3h-3V9h3V6h2v3h3V11z"
				/>
				<path
					d="M14,2c-4.411,0-8,3.589-8,8c0,1.665,0.512,3.211,1.386,4.493l-4.946,4.946c-0.586,0.586-0.586,1.535,0,2.121
		C2.732,21.854,3.116,22,3.5,22s0.768-0.146,1.061-0.439l4.946-4.946C10.789,17.488,12.335,18,14,18c4.411,0,8-3.589,8-8
		S18.411,2,14,2z M14,16c-3.309,0-6-2.691-6-6s2.691-6,6-6s6,2.691,6,6S17.309,16,14,16z"
				/>
				<polygon points="15,6 13,6 13,9 10,9 10,11 13,11 13,14 15,14 15,11 18,11 18,9 15,9 	" />
			</g>
		</SvgIcon>
	);
};

export const SaveIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<defs>
					<rect id="SVGID_1_" x="-948" y="-369.18" width="2000" height="2500" />
				</defs>
			</g>
			<g>
				<defs>
					<rect id="SVGID_3_" x="-948" y="-369.18" width="2000" height="2500" />
				</defs>
			</g>
			<path
				d="M18,2L18,2H6H4C2.9,2,2,2.9,2,4v16c0,1.11,0.9,2,2,2h1.99h12H20c1.11,0,2-0.89,2-2V6L18,2z M16,4v2h-5V4H16z M9,4v2H8V4H9z
                M7.99,20v-7h8v7H7.99z M20,20h-2.01v-9h-12v9H4V4h2v4h12V4.83l2,2V20z"
			/>
		</SvgIcon>
	);
};

export const BrightnessIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path
					fill="none"
					d="M12,8.5c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5s3.5-1.57,3.5-3.5S13.93,8.5,12,8.5z"
				/>
				<path
					d="M12,6.5c-3.037,0-5.5,2.463-5.5,5.5c0,3.035,2.463,5.5,5.5,5.5c3.035,0,5.5-2.465,5.5-5.5C17.5,8.963,15.035,6.5,12,6.5z
		 M12,15.5c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5s3.5,1.57,3.5,3.5S13.93,15.5,12,15.5z"
				/>
				<rect x="11" y="2" width="2" height="3" />
				<rect x="11" y="19" width="2" height="3" />
				<rect
					x="17.01"
					y="4.489"
					transform="matrix(0.707 0.7072 -0.7072 0.707 9.5134 -10.9823)"
					width="2"
					height="3.001"
				/>
				<rect
					x="4.99"
					y="16.511"
					transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 -2.5108 34.9815)"
					width="2"
					height="3"
				/>
				<rect x="19" y="11" width="3" height="2" />
				<rect x="2" y="11" width="3" height="2" />
				<rect
					x="16.51"
					y="17.011"
					transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 18.0099 43.4814)"
					width="3"
					height="2"
				/>
				<rect
					x="4.489"
					y="4.99"
					transform="matrix(0.7071 0.7071 -0.7071 0.7071 5.99 -2.4807)"
					width="3"
					height="2"
				/>
			</g>
		</SvgIcon>
	);
};
export const ContrastIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path
					fill="none"
					d="M4,12c0,2.205,0.897,4.205,2.346,5.654L17.654,6.346C16.205,4.897,14.205,4,12,4C7.589,4,4,7.589,4,12z"
				/>
				<path
					d="M21.998,11.956c-0.002-0.314-0.017-0.628-0.048-0.941c-0.015-0.154-0.044-0.305-0.066-0.457
		c-0.024-0.17-0.044-0.341-0.077-0.51c-0.034-0.172-0.081-0.339-0.124-0.508c-0.037-0.147-0.069-0.295-0.113-0.441
		c-0.05-0.165-0.111-0.323-0.17-0.484c-0.053-0.147-0.101-0.295-0.161-0.441c-0.061-0.147-0.133-0.289-0.201-0.433
		c-0.071-0.152-0.139-0.306-0.219-0.455c-0.072-0.134-0.154-0.261-0.231-0.392c-0.09-0.15-0.175-0.302-0.272-0.449
		c-0.093-0.138-0.195-0.267-0.294-0.4c-0.097-0.129-0.187-0.261-0.289-0.386c-0.171-0.208-0.354-0.406-0.542-0.599
		c-0.041-0.043-0.076-0.089-0.118-0.131v0C17.262,3.12,14.762,2,12,2C6.477,2,2,6.477,2,12c0,2.762,1.12,5.262,2.929,7.071
		c0.029,0.028,0.061,0.053,0.089,0.081c0.207,0.201,0.419,0.396,0.642,0.58c0.12,0.099,0.247,0.185,0.37,0.276
		c0.138,0.104,0.273,0.21,0.417,0.307c0.143,0.095,0.291,0.178,0.437,0.265c0.134,0.08,0.266,0.165,0.404,0.239
		c0.146,0.077,0.295,0.144,0.444,0.214c0.148,0.069,0.293,0.143,0.445,0.206c0.141,0.058,0.284,0.104,0.426,0.156
		c0.166,0.06,0.33,0.123,0.5,0.174c0.138,0.042,0.278,0.072,0.417,0.107c0.177,0.046,0.352,0.095,0.532,0.13
		c0.155,0.031,0.311,0.048,0.467,0.071c0.167,0.025,0.332,0.056,0.501,0.072c0.267,0.026,0.536,0.036,0.804,0.041
		C11.882,21.992,11.94,22,12,22s0.118-0.008,0.178-0.009c0.268-0.005,0.536-0.015,0.804-0.041c0.169-0.017,0.333-0.047,0.5-0.072
		c0.156-0.022,0.312-0.04,0.468-0.071c0.18-0.035,0.354-0.084,0.529-0.129c0.141-0.036,0.281-0.066,0.421-0.108
		c0.167-0.051,0.329-0.113,0.493-0.172c0.145-0.053,0.29-0.1,0.433-0.159c0.148-0.062,0.292-0.134,0.437-0.202
		c0.151-0.071,0.304-0.139,0.452-0.218c0.135-0.072,0.263-0.154,0.394-0.232c0.15-0.09,0.301-0.174,0.447-0.271
		c0.138-0.093,0.268-0.196,0.401-0.295c0.128-0.096,0.26-0.186,0.385-0.288c0.208-0.171,0.405-0.354,0.6-0.542
		c0.042-0.041,0.089-0.076,0.131-0.118c0.044-0.044,0.081-0.093,0.124-0.138c0.185-0.191,0.366-0.386,0.535-0.592
		c0.108-0.131,0.202-0.27,0.303-0.405c0.094-0.126,0.191-0.249,0.279-0.38c0.103-0.152,0.192-0.312,0.285-0.469
		c0.073-0.123,0.151-0.244,0.219-0.371c0.084-0.156,0.155-0.316,0.23-0.477c0.063-0.137,0.132-0.271,0.19-0.411
		c0.062-0.152,0.114-0.308,0.169-0.462c0.056-0.154,0.114-0.306,0.162-0.463c0.046-0.152,0.08-0.308,0.118-0.461
		c0.041-0.162,0.087-0.323,0.119-0.488c0.035-0.176,0.056-0.353,0.081-0.528c0.021-0.147,0.049-0.292,0.063-0.441
		c0.031-0.313,0.046-0.628,0.048-0.942C21.998,12.029,22,12.015,22,12C22,11.985,21.998,11.971,21.998,11.956z M6.346,17.654
		C4.897,16.205,4,14.205,4,12c0-4.411,3.589-8,8-8c2.205,0,4.205,0.897,5.654,2.346L6.346,17.654z"
				/>
			</g>
		</SvgIcon>
	);
};
export const GammaIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<polygon fill="none" points="4,20 20,4 4,4 	" />
				<path d="M21,2H3C2.448,2,2,2.448,2,3v18c0,0.553,0.448,1,1,1h18c0.553,0,1-0.447,1-1V3C22,2.448,21.553,2,21,2z M4,20V4h16L4,20z" />
			</g>
		</SvgIcon>
	);
};
export const NegativeIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<rect x="15" y="4" fill="none" width="5" height="16" />
				<path d="M10,2H3C2.448,2,2,2.448,2,3v18c0,0.553,0.448,1,1,1h7c0.552,0,1-0.447,1-1V3C11,2.448,10.552,2,10,2z" />
				<path
					d="M21,2h-7c-0.553,0-1,0.448-1,1v18c0,0.553,0.447,1,1,1h7c0.553,0,1-0.447,1-1V3C22,2.448,21.553,2,21,2z M20,20h-5V4h5V20z
		"
				/>
			</g>
		</SvgIcon>
	);
};
export const SharpenIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<polygon fill="none" points="12,6.483 5.231,20 18.768,20 	" />
				<path d="M12,2L2,22h20L12,2z M12,6.483L18.768,20H5.231L12,6.483z" />
			</g>
		</SvgIcon>
	);
};
export const SmoothIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path
					fill="none"
					d="M12,5.39C9.569,8.867,7,13.208,7,15c0,2.757,2.243,5,5,5s5-2.243,5-5C17,13.205,14.432,8.865,12,5.39z
		 M12,18.5c-0.552,0-1-0.447-1-1s0.448-1,1-1c0.827,0,1.5-0.673,1.5-1.5c0-0.553,0.447-1,1-1s1,0.447,1,1
		C15.5,16.93,13.93,18.5,12,18.5z"
				/>
				<path
					d="M12,2c0,0-7,9.135-7,13c0,3.866,3.134,7,7,7c3.867,0,7-3.134,7-7C19,11.135,12,2,12,2z M12,20c-2.757,0-5-2.243-5-5
		c0-1.792,2.569-6.133,5-9.61c2.431,3.475,5,7.815,5,9.61C17,17.757,14.757,20,12,20z"
				/>
				<path
					d="M14.5,14c-0.553,0-1,0.447-1,1c0,0.827-0.673,1.5-1.5,1.5c-0.552,0-1,0.447-1,1s0.448,1,1,1c1.93,0,3.5-1.57,3.5-3.5
		C15.5,14.447,15.053,14,14.5,14z"
				/>
			</g>
		</SvgIcon>
	);
};

export const RIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path
					fill="none"
					d="M14.86,11.702c0.322-0.448,0.482-1.006,0.482-1.671c0-0.492-0.08-0.926-0.239-1.299
		c-0.159-0.374-0.394-0.688-0.7-0.94c-0.309-0.253-0.686-0.444-1.132-0.574s-0.954-0.194-1.524-0.194h-3.5v9.953h1.729v-3.836h1.928
		l1.996,3.836h1.853v-0.09l-2.235-4.148C14.092,12.496,14.54,12.15,14.86,11.702z M13.148,11.289
		c-0.155,0.146-0.349,0.26-0.581,0.342s-0.503,0.123-0.813,0.123H9.977V8.418h1.771c0.328,0,0.609,0.039,0.844,0.119
		c0.235,0.08,0.428,0.193,0.578,0.342s0.262,0.326,0.335,0.533s0.109,0.438,0.109,0.693c0,0.242-0.039,0.463-0.116,0.664
		C13.42,10.97,13.304,11.143,13.148,11.289z"
				/>
				<path
					d="M13.504,9.412c-0.073-0.207-0.185-0.385-0.335-0.533s-0.343-0.262-0.578-0.342c-0.234-0.08-0.516-0.119-0.844-0.119H9.977
		v3.336h1.777c0.31,0,0.581-0.041,0.813-0.123s0.426-0.196,0.581-0.342c0.155-0.146,0.271-0.319,0.349-0.52
		c0.077-0.201,0.116-0.422,0.116-0.664C13.613,9.851,13.577,9.619,13.504,9.412z"
				/>
				<path
					d="M12,2C6.48,2,2,6.475,2,12s4.48,10,10,10c5.527,0,10-4.475,10-10S17.527,2,12,2z M15.753,16.977H13.9l-1.996-3.836H9.977
		v3.836H8.247V7.023h3.5c0.57,0,1.078,0.064,1.524,0.194s0.823,0.321,1.132,0.574c0.307,0.253,0.541,0.566,0.7,0.94
		c0.159,0.373,0.239,0.807,0.239,1.299c0,0.665-0.16,1.223-0.482,1.671c-0.32,0.448-0.769,0.794-1.343,1.036l2.235,4.148V16.977z"
				/>
			</g>
		</SvgIcon>
	);
};
export const GIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path
					fill="none"
					d="M12.185,13.182h2.051v1.949c-0.06,0.063-0.136,0.131-0.229,0.201c-0.094,0.07-0.214,0.136-0.359,0.195
		c-0.146,0.059-0.324,0.107-0.537,0.146c-0.211,0.039-0.465,0.059-0.762,0.059c-0.4,0-0.76-0.076-1.076-0.227
		c-0.317-0.15-0.586-0.369-0.807-0.656c-0.222-0.287-0.391-0.641-0.51-1.062s-0.178-0.905-0.178-1.452v-0.67
		c0-0.538,0.049-1.018,0.146-1.439c0.099-0.421,0.246-0.776,0.445-1.066C10.567,8.87,10.816,8.65,11.114,8.5
		c0.299-0.15,0.65-0.226,1.057-0.226c0.338,0,0.628,0.045,0.871,0.137c0.244,0.091,0.449,0.216,0.615,0.376
		c0.167,0.159,0.298,0.349,0.394,0.567s0.164,0.458,0.205,0.718h1.695c-0.06-0.465-0.178-0.893-0.355-1.282
		s-0.422-0.726-0.731-1.008c-0.31-0.283-0.69-0.503-1.142-0.66s-0.979-0.235-1.586-0.235c-0.643,0-1.217,0.106-1.723,0.321
		C9.908,7.422,9.479,7.734,9.129,8.145s-0.62,0.912-0.807,1.507s-0.28,1.271-0.28,2.027v0.656c0,0.761,0.104,1.438,0.311,2.03
		c0.208,0.592,0.498,1.091,0.872,1.496c0.374,0.406,0.821,0.716,1.343,0.93c0.522,0.215,1.096,0.322,1.72,0.322
		c0.556,0,1.04-0.049,1.452-0.147c0.413-0.099,0.766-0.219,1.061-0.362c0.293-0.144,0.534-0.299,0.721-0.465
		s0.333-0.318,0.438-0.455V11.87h-3.773V13.182z"
				/>
				<g>
					<path
						d="M12,2C6.48,2,2,6.475,2,12s4.48,10,10,10c5.527,0,10-4.475,10-10S17.527,2,12,2z M15.958,15.684
			c-0.104,0.137-0.251,0.289-0.438,0.455s-0.428,0.321-0.721,0.465c-0.295,0.144-0.647,0.264-1.061,0.362
			c-0.412,0.099-0.896,0.147-1.452,0.147c-0.624,0-1.197-0.107-1.72-0.322c-0.521-0.214-0.969-0.523-1.343-0.93
			c-0.374-0.405-0.664-0.904-0.872-1.496c-0.207-0.593-0.311-1.27-0.311-2.03v-0.656c0-0.757,0.094-1.433,0.28-2.027
			s0.456-1.097,0.807-1.507s0.779-0.723,1.285-0.937c0.506-0.215,1.08-0.321,1.723-0.321c0.606,0,1.135,0.078,1.586,0.235
			s0.832,0.377,1.142,0.66c0.31,0.282,0.554,0.618,0.731,1.008s0.296,0.817,0.355,1.282h-1.695c-0.041-0.26-0.109-0.499-0.205-0.718
			s-0.227-0.408-0.394-0.567c-0.166-0.16-0.371-0.285-0.615-0.376c-0.243-0.092-0.533-0.137-0.871-0.137
			c-0.406,0-0.758,0.075-1.057,0.226c-0.298,0.15-0.547,0.37-0.744,0.659c-0.199,0.29-0.347,0.646-0.445,1.066
			c-0.098,0.422-0.146,0.901-0.146,1.439v0.67c0,0.547,0.059,1.03,0.178,1.452s0.288,0.775,0.51,1.062
			c0.221,0.287,0.489,0.506,0.807,0.656c0.316,0.15,0.676,0.227,1.076,0.227c0.297,0,0.551-0.02,0.762-0.059
			c0.213-0.039,0.392-0.088,0.537-0.146c0.146-0.06,0.266-0.125,0.359-0.195c0.093-0.07,0.169-0.138,0.229-0.201v-1.949h-2.051
			V11.87h3.773V15.684z"
					/>
				</g>
			</g>
		</SvgIcon>
	);
};
export const BIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path
					fill="none"
					d="M15.139,12.656c-0.141-0.201-0.314-0.375-0.527-0.523c-0.211-0.147-0.461-0.261-0.748-0.338
		c0.473-0.201,0.834-0.483,1.08-0.848c0.246-0.365,0.369-0.775,0.369-1.23c0-0.465-0.078-0.867-0.236-1.207
		c-0.156-0.339-0.385-0.618-0.68-0.837c-0.297-0.219-0.658-0.382-1.088-0.489c-0.428-0.106-0.911-0.16-1.448-0.16H8.449v9.953h3.65
		c0.537,0,1.02-0.062,1.445-0.186s0.789-0.307,1.088-0.55c0.297-0.243,0.525-0.547,0.684-0.909c0.156-0.362,0.234-0.783,0.234-1.262
		c0-0.26-0.033-0.51-0.102-0.752C15.381,13.077,15.277,12.856,15.139,12.656z M10.179,8.418h1.682c0.592,0,1.028,0.109,1.31,0.328
		c0.279,0.219,0.42,0.574,0.42,1.066c0,0.446-0.152,0.792-0.455,1.035c-0.303,0.244-0.724,0.366-1.261,0.366h-1.695V8.418z
		 M13.719,14.693c-0.072,0.187-0.182,0.348-0.328,0.481c-0.145,0.134-0.326,0.238-0.543,0.312c-0.216,0.072-0.466,0.109-0.748,0.109
		h-1.921v-3.11h1.996c0.583,0,1.005,0.141,1.265,0.423c0.26,0.283,0.389,0.67,0.389,1.162
		C13.828,14.299,13.793,14.506,13.719,14.693z"
				/>
				<path
					d="M12,2C6.48,2,2,6.475,2,12s4.48,10,10,10c5.527,0,10-4.475,10-10S17.527,2,12,2z M15.316,15.332
		c-0.158,0.362-0.387,0.666-0.684,0.909c-0.299,0.243-0.662,0.427-1.088,0.55s-0.908,0.186-1.445,0.186h-3.65V7.023h3.411
		c0.537,0,1.021,0.054,1.448,0.16c0.43,0.107,0.791,0.271,1.088,0.489c0.295,0.219,0.523,0.498,0.68,0.837
		c0.158,0.34,0.236,0.742,0.236,1.207c0,0.455-0.123,0.865-0.369,1.23c-0.246,0.364-0.607,0.646-1.08,0.848
		c0.287,0.077,0.537,0.19,0.748,0.338c0.213,0.148,0.387,0.322,0.527,0.523c0.139,0.2,0.242,0.421,0.311,0.662
		c0.068,0.242,0.102,0.492,0.102,0.752C15.551,14.549,15.473,14.97,15.316,15.332z"
				/>
				<path
					d="M12.175,12.485h-1.996v3.11H12.1c0.282,0,0.532-0.037,0.748-0.109c0.217-0.073,0.398-0.178,0.543-0.312
		c0.146-0.134,0.256-0.295,0.328-0.481c0.074-0.188,0.109-0.395,0.109-0.623c0-0.492-0.129-0.879-0.389-1.162
		C13.18,12.626,12.758,12.485,12.175,12.485z"
				/>
				<path
					d="M13.135,10.848c0.303-0.243,0.455-0.589,0.455-1.035c0-0.492-0.141-0.848-0.42-1.066c-0.281-0.219-0.718-0.328-1.31-0.328
		h-1.682v2.796h1.695C12.411,11.214,12.832,11.092,13.135,10.848z"
				/>
			</g>
		</SvgIcon>
	);
};
export const MontageIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<circle cx="12" cy="4" r="2" />
				<circle cx="12" cy="20" r="2" />
				<circle cx="20" cy="12" r="2" />
				<circle cx="4" cy="12" r="2" />
				<circle cx="17.657" cy="17.657" r="2" />
				<circle cx="6.343" cy="6.344" r="2" />
				<circle cx="6.343" cy="17.658" r="2" />
				<circle cx="17.656" cy="6.344" r="2" />
			</g>
		</SvgIcon>
	);
};

export const AreaIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<polygon
					fill="none"
					points="17,17.002 15,17.002 15,15.002 11,15.002 11,17.002 9,17.002 9,15.002 7,15.002 7,13.002 9,13.002
		9,9.002 7,9.002 7,7.002 9,7.002 9,4.002 4,4.002 4,20 20,20.002 20,15.002 17,15.002 	"
				/>
				<path
					d="M21,13.002H11v-10c0-0.552-0.448-1-1-1H3c-0.552,0-1,0.448-1,1V21c0,0.553,0.448,1,1,1l18,0.002c0.553,0,1-0.447,1-1v-7
		C22,13.449,21.553,13.002,21,13.002z M20,20.002L4,20V4.002h5v3H7v2h2v4H7v2h2v2h2v-2h4v2h2v-2h3V20.002z"
				/>
			</g>
		</SvgIcon>
	);
};
export const MeasureIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<polygon
					fill="none"
					points="4,20.002 9,20.002 9,18.002 7,18.002 7,16.002 9,16.002 9,13.002 7,13.002 7,11.002 9,11.002 9,8.002
		7,8.002 7,6.002 9,6.002 9,4.002 4,4.002 	"
				/>
				<polygon
					points="19.001,17.678 19.001,6.326 20.373,7.973 21.909,6.692 18.001,2.002 14.093,6.692 15.629,7.973 17.001,6.326
		17.001,17.678 15.629,16.031 14.093,17.312 18.001,22.002 21.909,17.312 20.373,16.031 	"
				/>
				<path
					d="M10,2.002H3c-0.552,0-1,0.448-1,1v18c0,0.553,0.448,1,1,1h7c0.552,0,1-0.447,1-1v-3v-2v-3v-2v-3v-2v-3
		C11,2.45,10.552,2.002,10,2.002z M9,6.002H7v2h2v3H7v2h2v3H7v2h2v2H4v-16h5V6.002z"
				/>
			</g>
		</SvgIcon>
	);
};
export const MeasureMultiPointIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<circle fill="none" cx="18" cy="11.999" r="2" />
				<polygon
					fill="none"
					points="4,20.002 9,20.002 9,18.002 7,18.002 7,16.002 9,16.002 9,12.875 7,12.875 7,10.875 9,10.875 9,8.002
		7,8.002 7,6.002 9,6.002 9,4.002 4,4.002 	"
				/>
				<path
					d="M18,7.999c-2.209,0-4,1.791-4,4c0,2.207,1.791,4,4,4c2.207,0,4-1.793,4-4C22,9.79,20.207,7.999,18,7.999z M18,13.999
		c-1.103,0-2-0.897-2-2c0-1.103,0.897-2,2-2s2,0.897,2,2C20,13.102,19.103,13.999,18,13.999z"
				/>
				<path
					d="M10,2.002H3c-0.552,0-1,0.448-1,1v18c0,0.553,0.448,1,1,1h7c0.552,0,1-0.447,1-1v-3v-2v-3.127v-2V8.002v-2v-3
		C11,2.45,10.552,2.002,10,2.002z M9,6.002H7v2h2v2.873H7v2h2v3.127H7v2h2v2H4v-16h5V6.002z"
				/>
			</g>
		</SvgIcon>
	);
};
export const PDTIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<polygon
					fill="none"
					points="18,4.5 14,4.5 14,6 10,6 10,4.5 6,4.5 6,6 4.5,6 4.5,10.002 6,10.002 6,14.002 4.5,14.002 4.5,18
		6,18 6,19.5 10,19.5 10,18 14,18 14,19.5 18,19.5 18,18 19.5,18 19.5,13.998 18,13.998 18,9.998 19.5,9.998 19.5,6 18,6 	"
				/>
				<path
					d="M22,6V2h-4v1.5h-4V2h-4v1.5H6V2H2v4h1.5v4.002H2v4h1.5V18H2v4h4v-1.5h4V22h4v-1.5h4V22h4v-4h-1.5v-4.002H22v-4h-1.5V6H22z
		 M19.5,9.998H18v4h1.5V18H18v1.5h-4V18h-4v1.5H6V18H4.5v-3.998H6v-4H4.5V6H6V4.5h4V6h4V4.5h4V6h1.5V9.998z"
				/>
			</g>
		</SvgIcon>
	);
};

export const AnnotationIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path
					fill="none"
					d="M18.736,5H5.264C5.118,5,5,5.118,5,5.264v12.474C5,17.882,5.118,18,5.264,18H9h0.605l0.504,0.336L12,19.597
		l1.891-1.261L14.395,18H15h3.736C18.882,18,19,17.882,19,17.737V5.264C19,5.118,18.882,5,18.736,5z M17.089,15H7v-2h10.089V15z
		 M17.089,10H7V8h10.089V10z"
				/>
				<path
					d="M18.736,3H5.264C4.013,3,3,4.014,3,5.264v12.474C3,18.987,4.013,20,5.264,20H9l3,2l3-2h3.736
		C19.987,20,21,18.987,21,17.737V5.264C21,4.014,19.987,3,18.736,3z M19,17.737C19,17.882,18.882,18,18.736,18H15h-0.605
		l-0.504,0.336L12,19.597l-1.891-1.261L9.605,18H9H5.264C5.118,18,5,17.882,5,17.737V5.264C5,5.118,5.118,5,5.264,5h13.473
		C18.882,5,19,5.118,19,5.264V17.737z"
				/>
				<rect x="7" y="8" width="10.089" height="2" />
				<rect x="7" y="13" width="10.089" height="2" />
			</g>
		</SvgIcon>
	);
};
export const ArrowIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<path
				d="M17.281,8.094l-1.28,1.537l1.646,1.372H3c-0.552,0-1,0.448-1,1s0.448,1,1,1h14.647l-1.646,1.372l1.28,1.536l4.691-3.908
	L17.281,8.094z"
			/>
		</SvgIcon>
	);
};
export const CircleIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path fill="none" d="M12,4c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S16.411,4,12,4z" />
				<path
					d="M12,2C6.478,2,2,6.477,2,12c0,5.522,4.478,10,10,10s10-4.478,10-10C22,6.477,17.522,2,12,2z M12,20c-4.411,0-8-3.589-8-8
		s3.589-8,8-8s8,3.589,8,8S16.411,20,12,20z"
				/>
			</g>
		</SvgIcon>
	);
};
export const EllipseIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path
					fill="none"
					d="M18.364,5.636c-1.32-1.321-2.997-1.598-4.171-1.598c-2.446,0-4.998,1.149-7.001,3.153
		c-1.758,1.758-2.86,3.935-3.104,6.13c-0.225,2.027,0.325,3.818,1.548,5.042c1.32,1.32,2.998,1.597,4.172,1.597
		c2.446,0,4.998-1.148,7.001-3.151c1.757-1.758,2.859-3.935,3.103-6.13C20.138,8.65,19.588,6.859,18.364,5.636z"
				/>
				<path
					d="M19.778,4.222c-1.47-1.47-3.456-2.184-5.586-2.183c-2.85,0-5.956,1.28-8.415,3.739c-4.296,4.296-4.992,10.564-1.556,14
		c1.469,1.47,3.456,2.183,5.586,2.183c2.851,0,5.956-1.278,8.415-3.737C22.52,13.927,23.214,7.657,19.778,4.222z M16.81,16.809
		c-2.003,2.003-4.555,3.151-7.001,3.151c-1.175,0-2.852-0.276-4.172-1.597c-1.224-1.224-1.773-3.015-1.548-5.042
		c0.244-2.195,1.346-4.372,3.104-6.13c2.003-2.003,4.556-3.153,7.001-3.153c1.174,0,2.851,0.277,4.171,1.598
		c1.224,1.223,1.773,3.014,1.548,5.042C19.669,12.874,18.566,15.051,16.81,16.809z"
				/>
			</g>
		</SvgIcon>
	);
};
export const FreehandIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<polyline
				fill="none"
				stroke="#000000"
				strokeWidth="2"
				strokeMiterlimit="10"
				points="50.75,-62 50.75,-78 62.75,-78 "
			/>
			<rect x="52.75" y="-76" width="13" height="17" />
			<path
				d="M20,2c-0.702,0-1.318,0.364-1.675,0.912c-3.521-0.177-6.698-0.166-9.621,0.058C6.999,3.1,4.61,3.528,3.564,5.74
	c-0.746,1.578-0.795,3.338-0.137,4.831c0.448,1.016,1.434,2.365,3.583,3.025c0.946,0.29,2.035,0.36,3.087,0.429
	c3.039,0.197,4.183,0.465,4.14,2.517c-0.015,0.713-0.265,1.245-0.785,1.676c-1.467,1.211-4.718,1.331-7.603,1.027
	C5.551,18.515,4.837,18,4,18c-1.104,0-2,0.895-2,2s0.896,2,2,2c0.641,0,1.205-0.307,1.571-0.775
	c0.819,0.088,1.794,0.159,2.822,0.159c2.274,0,4.786-0.348,6.333-1.626c0.962-0.794,1.484-1.892,1.512-3.175
	c0.087-4.16-3.583-4.397-6.01-4.554c-0.981-0.063-1.908-0.124-2.63-0.345c-1.129-0.347-1.938-1.011-2.34-1.92
	C4.839,8.816,4.883,7.631,5.373,6.594C5.836,5.615,6.91,5.112,8.857,4.963c2.839-0.217,5.934-0.227,9.371-0.055
	C18.56,5.554,19.225,6,20,6c1.104,0,2-0.895,2-2S21.104,2,20,2z"
			/>
		</SvgIcon>
	);
};
export const LineIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<path
				d="M20,2c-1.104,0-2,0.895-2,2c0,0.171,0.028,0.335,0.068,0.493L4.53,18.08C4.36,18.033,4.185,18,4,18c-1.104,0-2,0.895-2,2
	s0.896,2,2,2s2-0.895,2-2c0-0.171-0.028-0.335-0.068-0.493L19.471,5.92C19.64,5.967,19.815,6,20,6c1.104,0,2-0.895,2-2
	S21.104,2,20,2z"
			/>
		</SvgIcon>
	);
};
export const TextIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<path
				d="M20.387,2H3.629L3.387,6.813h0.575c0.07-0.928,0.292-1.665,0.666-2.21C5.001,4.059,5.451,3.69,5.976,3.499
	C6.379,3.357,7.06,3.287,8.019,3.287h2.467v15.156c0,1.15-0.111,1.888-0.333,2.211C9.79,21.178,9.174,21.44,8.307,21.44H7.58V22
	h8.703v-0.56h-0.711c-0.797,0-1.387-0.213-1.771-0.637c-0.271-0.312-0.408-1.1-0.408-2.361V3.287h2.891
	c0.848,0,1.531,0.139,2.051,0.417c0.521,0.277,0.938,0.709,1.25,1.294c0.191,0.363,0.342,0.969,0.453,1.816h0.576L20.387,2z"
			/>
		</SvgIcon>
	);
};
export const RectangleIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<rect x="6" y="4" fill="none" width="12" height="16" />
				<path d="M19,2H5C4.448,2,4,2.448,4,3v18c0,0.553,0.448,1,1,1h14c0.553,0,1-0.447,1-1V3C20,2.448,19.553,2,19,2z M18,20H6V4h12V20z" />
			</g>
		</SvgIcon>
	);
};

export const BookmarkIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<polygon points="19,22 12,18 5,22 5,2 19,2 " />
		</SvgIcon>
	);
};
export const FirstFrameIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<polygon points="9.001,12 20.999,22 20.999,2 	" />
				<rect x="3.001" y="1.999" width="3" height="20" />
			</g>
		</SvgIcon>
	);
};
export const LastFrameIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<polygon points="3.001,21.999 14.999,11.999 3.001,1.999 	" />
				<rect x="17.999" y="2" width="3" height="20" />
			</g>
		</SvgIcon>
	);
};
export const NextFrameIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<polygon points="9.001,2 9.001,22 21,12 	" />
				<rect x="3" y="2" width="3" height="20" />
			</g>
		</SvgIcon>
	);
};
export const PlayIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<polygon points="6.001,22 6.001,2 17.999,12 " />
		</SvgIcon>
	);
};
export const PreviousFrameIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<polygon points="14.998,22 14.998,2 3,12 	" />
				<rect x="18" y="2" width="3" height="20" />
			</g>
		</SvgIcon>
	);
};
export const SavedIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path
					d="M18,2h-2v4.5c0,0.55-0.45,1-1,1H7c-0.55,0-1-0.45-1-1V2H4C2.9,2,2,2.9,2,4v16c0,1.11,0.9,2,2,2h16c1.11,0,2-0.89,2-2V6
		L18,2z M19,20H5v-7h14V20z"
				/>
				<polygon points="14,6 14,2 12,2 12,6 12,6 14,6 	" />
			</g>
		</SvgIcon>
	);
};
export const UnselectedIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<rect x="2" y="3" width="18" height="18" rx="5" />
		</SvgIcon>
	);
};
export const SelectedIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path
					d="M17.139,2H6.863C4.182,2,2,4.182,2,6.863v10.275C2,19.819,4.182,22,6.863,22h10.275C19.819,22,22,19.819,22,17.139V6.863
		C22,4.182,19.819,2,17.139,2z M10.264,17.001L6,12.585l1.412-1.463l2.801,2.9L16.539,7L18,8.411L10.264,17.001z"
				/>
			</g>
		</SvgIcon>
	);
};

export const CompareIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path fill="none" d="M7,16V9H4v11h11v-3H8C7.448,17,7,16.553,7,16z" />
				<path fill="none" d="M9,7h7c0.553,0,1,0.448,1,1v7h3V4H9V7z" />
				<path
					d="M21,2H8C7.448,2,7,2.448,7,3v4H3C2.448,7,2,7.448,2,8v13c0,0.553,0.448,1,1,1h13c0.553,0,1-0.447,1-1v-4h4
		c0.553,0,1-0.447,1-1V3C22,2.448,21.553,2,21,2z M15,20H4V9h3v7c0,0.553,0.448,1,1,1h7V20z M20,15h-3V8c0-0.552-0.447-1-1-1H9V4h11
		V15z"
				/>
			</g>
		</SvgIcon>
	);
};
export const OpenIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<circle fill="none" cx="6.5" cy="16.557" r="3" />
				<circle fill="none" cx="17.5" cy="16.557" r="3" />
				<path
					d="M21.916,15.724l-2.422-7.229c-0.024-1.376-0.847-2.552-2.021-3.103C17.485,5.299,17.5,5.205,17.5,5.106
		c0-1.194-0.895-2.163-2-2.163c-1.104,0-2,0.969-2,2.163c0,0.297,0.056,0.579,0.156,0.837c0.166-0.131-0.247,0.221-0.522,0.613
		h-2.267c-0.274-0.393-0.688-0.743-0.523-0.613c0.101-0.258,0.156-0.54,0.156-0.837c0-1.194-0.895-2.163-2-2.163
		c-1.104,0-2,0.969-2,2.163c0,0.099,0.014,0.192,0.027,0.287C5.354,5.943,4.53,7.118,4.506,8.495l-2.422,7.229
		C2.033,15.994,2,16.271,2,16.557c0,2.483,2.015,4.5,4.5,4.5s4.5-2.017,4.5-4.5c0,0,0-0.121,0-0.188c0-0.553,0.447-1,1-1
		s1,0.447,1,1c0,0.066,0,0.188,0,0.188c0,2.483,2.015,4.5,4.5,4.5s4.5-2.017,4.5-4.5C22,16.271,21.967,15.994,21.916,15.724z
		 M6.5,19.557c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S8.154,19.557,6.5,19.557z M13,11.369h-2v-2h2V11.369z M17.5,19.557
		c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S19.154,19.557,17.5,19.557z"
				/>
			</g>
		</SvgIcon>
	);
};

export const PointerIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path
					d="M17.3,13.2L7.2,3.1C7.1,3,6.9,2.9,6.8,3S6.6,3.2,6.6,3.3v14.2c0,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.1,0.3,0l2.4-1
				c0.3-0.1,0.6-0.1,0.9,0c0.3,0.1,0.5,0.3,0.6,0.6l1,2.4c0.3,0.6,0.9,1,1.5,1c0.2,0,0.4,0,0.6-0.1c0.8-0.3,1.3-1.3,0.9-2.2l-1-2.5
				c-0.2-0.6,0-1.3,0.6-1.5l2.5-1c0.1,0,0.2-0.1,0.2-0.3C17.4,13.4,17.4,13.3,17.3,13.2z M14.4,14.1c-1,0.4-1.4,1.5-1,2.4l1,2.5
				c0.1,0.2,0.1,0.5,0,0.7c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.5,0.1-0.7,0c-0.2-0.1-0.4-0.3-0.5-0.5l-1-2.4c-0.2-0.5-0.5-0.8-1-1
				c-0.2-0.1-0.5-0.1-0.7-0.1c-0.2,0-0.5,0-0.7,0.1L7.3,17V4.2l9.1,9.1L14.4,14.1z"
				/>
				<path d="M8.2,15.9c0.2,0,0.4-0.2,0.4-0.4V9.5c0-0.2-0.2-0.4-0.4-0.4S7.9,9.3,7.9,9.5v6.1C7.9,15.7,8,15.9,8.2,15.9z" />
				<path d="M8.2,8.2c0.2,0,0.4-0.2,0.4-0.4V6.9c0-0.2-0.2-0.4-0.4-0.4S7.9,6.7,7.9,6.9v0.9C7.9,8,8,8.2,8.2,8.2z" />
			</g>
		</SvgIcon>
	);
};

export const AngleIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path
					d="M17.307,14.185l-1.279,1.536l1.539,1.281h-4.784c-0.448-2.986-2.865-5.348-5.917-5.779V6.218l1.461,1.754l1.537-1.28
		L5.955,2L2.047,6.692l1.537,1.28l1.282-1.539v12.569h12.916l-1.754,1.461L17.307,22L22,18.092L17.307,14.185z M6.865,13.244
		c1.946,0.385,3.483,1.871,3.891,3.758H6.865V13.244z"
				/>
			</g>
		</SvgIcon>
	);
};
export const HistoryIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path
					d="M10.947,6.509c-0.582,0-1.053,0.471-1.053,1.052v6.085l5.009,1.251c0.085,0.021,0.17,0.032,0.256,0.032
		c0.472,0,0.9-0.318,1.021-0.798c0.14-0.563-0.202-1.135-0.767-1.276L12,12.002V7.561C12,6.98,11.529,6.509,10.947,6.509z"
				/>
				<path
					d="M12,2.002c-2.689,0-5.201,1.058-7.067,2.931L3.579,3.579v4.21h4.21L6.347,6.347C7.84,4.848,9.849,4.002,12,4.002
		c4.411,0,8,3.589,8,8s-3.589,8-8,8s-8-3.589-8-8H2c0,5.514,4.486,10,10,10c5.514,0,10-4.486,10-10C22,6.488,17.514,2.002,12,2.002z
		"
				/>
			</g>
		</SvgIcon>
	);
};
export const SplitODOSIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<rect x="11" y="2" width="2" height="3" />
				<rect x="11" y="19" width="2" height="3" />
				<rect x="11" y="7" width="2" height="4" />
				<rect x="11" y="13" width="2" height="4" />
				<path
					d="M5.5,4C3.57,4,2,5.57,2,7.5S3.57,11,5.5,11S9,9.43,9,7.5S7.43,4,5.5,4z M5.5,9C4.67,9,4,8.33,4,7.5S4.67,6,5.5,6
		S7,6.67,7,7.5S6.33,9,5.5,9z"
				/>
				<circle cx="18.5" cy="7.5" r="3.5" />
				<path
					d="M5.5,13C3.57,13,2,14.57,2,16.5C2,18.43,3.57,20,5.5,20S9,18.43,9,16.5C9,14.57,7.43,13,5.5,13z M5.5,18
		C4.67,18,4,17.33,4,16.5C4,15.67,4.67,15,5.5,15S7,15.67,7,16.5C7,17.33,6.33,18,5.5,18z"
				/>
				<circle cx="18.5" cy="16.5" r="3.5" />
			</g>
		</SvgIcon>
	);
};
export const TrashIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<g>
					<rect x="14" y="8" width="2" height="10" />
					<rect x="11" y="8" width="2" height="10" />
					<rect x="8" y="8" width="2" height="10" />
					<path
						d="M15.86,22H8.14C6.41,22,5,20.43,5,18.5V6H4V4h6V2h4v2h6v2h-1v12.5C19,20.43,17.59,22,15.86,22z M8.14,20h7.72
			c0.62,0,1.14-0.69,1.14-1.5V6H7v12.5C7,19.31,7.53,20,8.14,20z"
					/>
				</g>
			</g>
		</SvgIcon>
	);
};

export const CancelIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<polygon points="19.5,5.9 18.1,4.5 12,10.6 5.9,4.5 4.5,5.9 10.6,12 4.5,18.1 5.9,19.5 12,13.4 18.1,19.5 19.5,18.1 13.4,12 " />
		</SvgIcon>
	);
};

export const PadlockOpenIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path
					d="M17.5,12H9V7.219C9,5.444,10.345,4,11.999,4c1.653,0,2.999,1.444,2.999,3.219h2C16.998,4.341,14.756,2,11.999,2
		C9.243,2,7,4.341,7,7.219V12H6.5c-0.552,0-1,0.448-1,1v8c0,0.553,0.448,1,1,1h11c0.553,0,1-0.447,1-1v-8
		C18.5,12.448,18.053,12,17.5,12z M12,18.25c-0.69,0-1.25-0.56-1.25-1.25s0.56-1.25,1.25-1.25s1.25,0.56,1.25,1.25
		S12.69,18.25,12,18.25z"
				/>
			</g>
		</SvgIcon>
	);
};
export const PadlockCloseIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path
					fill="none"
					d="M14.998,9.219C14.998,7.444,13.652,6,11.999,6C10.345,6,9,7.444,9,9.219V12h5.999L14.998,9.219z"
				/>
				<path
					d="M17.5,12h-0.501l-0.001-2.781C16.998,6.341,14.756,4,11.999,4C9.243,4,7,6.341,7,9.219V12H6.5c-0.552,0-1,0.448-1,1v8
		c0,0.553,0.448,1,1,1h11c0.553,0,1-0.447,1-1v-8C18.5,12.448,18.053,12,17.5,12z M13.25,17c0,0.69-0.56,1.25-1.25,1.25
		s-1.25-0.56-1.25-1.25s0.56-1.25,1.25-1.25S13.25,16.31,13.25,17z M9,9.219C9,7.444,10.345,6,11.999,6
		c1.653,0,2.999,1.444,2.999,3.219L14.999,12H9V9.219z"
				/>
			</g>
		</SvgIcon>
	);
};
export const CEIcon = (props) => {
    return (
		<SvgIcon {...props} viewBox="0 0 280 200">
			<g>
				<path d="M110,199.498744A100,100 0 0 1 100,200A100,100 0 0 1 100,0A100,100 0 0 1 110,0.501256L110,30.501256A70,70 0 0 0 100,30A70,70 0 0 0 100,170A70,70 0 0 0 110,169.498744Z" fill="black"/>
				<path d="M280,199.498744A100,100 0 0 1 270,200A100,100 0 0 1 270,0A100,100 0 0 1 280,0.501256L280,30.501256A70,70 0 0 0 270,30A70,70 0 0 0 201.620283,85L260,85L260,115L201.620283,115A70,70 0 0 0 270,170A70,70 0 0 0 280,169.498744Z" fill="black"/>
			</g>
		</SvgIcon>
    );
};
export const ManufactureIcon = (props) => {
    return (
		<SvgIcon {...props} viewBox="0 0 201 251">
			<g>
				<path d="M.5 250.5v-120l25-50 25 50 25-50 25 50 25-50 25 50V.5h50v250z" fill="black"/>
					</g>
		</SvgIcon>
    );
};
export const LotIcon = (props) => {
    return (
		<SvgIcon {...props} viewBox="0 0 51.19 31.99">
			<g>
				<path d="M10.4,20.8V8H7.2V24h9.6V20.8H10.4m15.2-9.6a3.2,3.2,0,0,0-3.2,3.2v3.2a3.2,3.2,0,1,0,6.4,0V14.4a3.19,3.19,0,0,0-3.2-3.2m0-3.2a6.4,6.4,0,0,0-6.4,6.4v3.2A6.4,6.4,0,1,0,32,17.6V14.4A6.4,6.4,0,0,0,25.6,8m8.8,0v3.2h4V24h3.2V11.2h4V8H34.39M1.6,30.39h48V1.6H1.6ZM51.19,32H0V0H51.19Z" fill="black" fillRule="evenodd"/>
			</g>
		</SvgIcon>
    );
};
export const RefIcon = (props) => {
    return (
		<SvgIcon {...props} viewBox="0 0 51.19 31.99">
				<g>
					<g ><path d="M0,30H48V0H0Zm46.48-1.5H1.5V1.5h45Z" />
						<polygon points="35.24 16.49 41.24 16.49 41.24 13.49 35.24 13.49 35.24 10.5 42.74 10.5 42.74 7.5 32.24 7.5 32.24 22.49 35.24 22.49 35.24 16.49"/>
						<polygon points="29.24 19.49 21.74 19.49 21.74 16.49 28.49 16.49 28.49 13.49 21.74 13.49 21.74 10.5 29.24 10.5 29.24 7.5 18.74 7.5 18.74 22.49 29.24 22.49 29.24 19.49" />
						<g><path d="M16.45,22.49a.71.71,0,0,1-.71-.71V18.58a4.44,4.44,0,0,0-1.23-3.06,4.81,4.81,0,0,0-3.58-8H5.25v15h3V17.11h3.21a1.51,1.51,0,0,1,1.29,1.47v3.92Zm-5.51-8.38H8.25V10.5h2.69a1.81,1.81,0,1,1,0,3.61" transform="translate(0 0)" /></g></g>
				</g>
		</SvgIcon>
    );
};
export const InstIcon = (props) => {
    return (
		<SvgIcon {...props} viewBox="0 0 63.85 47.01">
			<g>
				<path xmlns="http://www.w3.org/2000/svg" d="M30.93,3A11.5,11.5,0,0,0,19.19,4.36,23.06,23.06,0,0,1,2,6.35V44.12a21.08,21.08,0,0,0,18.13-2.88,13.67,13.67,0,0,1,10.8-.56ZM41.15,21v2h3.24V34H41.15v2h14V34H51.88V21H41.15m7-10a3.74,3.74,0,1,0,3.74,3.74A3.74,3.74,0,0,0,48.13,11M44.66,4.36A11.5,11.5,0,0,0,32.92,3V40.68a13.67,13.67,0,0,1,10.8.56,21.07,21.07,0,0,0,18.13,2.88V6.35a23.06,23.06,0,0,1-17.19-2m19.19-.8v42A23.07,23.07,0,0,1,42.63,43a11.49,11.49,0,0,0-10.74.4,11.5,11.5,0,0,0-12.74.82A23.06,23.06,0,0,1,0,45.55v-42A21.07,21.07,0,0,0,20.17,1.41a13.49,13.49,0,0,1,11.76-.12,13.49,13.49,0,0,1,11.76.12A21.07,21.07,0,0,0,63.85,3.56" />
			</g>
		</SvgIcon>
    );
};


export const View11Icon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<rect x="2" y="2" className="st1" width="20" height="20" />
			</g>

		</SvgIcon>
	);
};
export const View21Icon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<rect x="13" y="2" width="9" height="20" />
				<rect x="2" y="2" width="9" height="20" />
			</g>
		</SvgIcon>
	);
};
export const View31Icon = (props) => {
	return (
		<SvgIcon {...props}>
			<rect x="9.3" y="2" width="5.3" height="20" />
			<rect x="2" y="2" width="5.3" height="20" />
			<rect x="16.7" y="2" width="5.3" height="20" />
		</SvgIcon>
	);
};
export const FitToScreeIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path d="M3,12c0.6,0,1-0.4,1-1V4h7c0.6,0,1-0.4,1-1s-0.4-1-1-1H3C2.4,2,2,2.5,2,3v8C2,11.6,2.4,12,3,12z" />
				<path d="M21,12c-0.6,0-1,0.4-1,1v7h-7c-0.6,0-1,0.4-1,1s0.4,1,1,1h8c0.6,0,1-0.4,1-1v-8C22,12.4,21.6,12,21,12z" />
				<path d="M7.2,20H5.4l7.1-7.1l0.3-0.3L20,5.4v1.8c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1V3c0-0.6-0.4-1-1-1h-4.2c-0.3,0-0.5,0.1-0.7,0.3
		c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.6,0.4,1,1,1h1.8l-7.1,7.1l-0.3,0.3L4,18.6v-1.8c0-0.6-0.4-1-1-1c-0.6,0-1,0.4-1,1V21
		c0,0.6,0.4,1,1,1h4.2c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7C8.2,20.4,7.8,20,7.2,20z"/>
			</g>
		</SvgIcon>
	);
};
export const Fullscreen2Icon = (props) => {
	return (
		<SvgIcon {...props}>
			<g>
				<path d="M5.4,4h1.8c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H3C2.4,2,2,2.4,2,3v4.2c0,0.3,0.1,0.5,0.3,0.7C2.5,8.1,2.7,8.2,3,8.2
		c0.6,0,1-0.4,1-1V5.4L8.5,10L10,8.5L5.4,4z"/>
				<path d="M18.6,20h-1.8c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1H21c0.6,0,1-0.4,1-1v-4.2c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.4-0.3-0.7-0.3
		c-0.6,0-1,0.4-1,1v1.8L15.5,14L14,15.5L18.6,20z"/>
				<path d="M21,8.2c0.6,0,1-0.4,1-1V3c0-0.6-0.4-1-1-1h-4.2c-0.3,0-0.5,0.1-0.7,0.3c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.6,0.4,1,1,1h1.8
		L14,8.5l1.4,1.4L20,5.4v1.8C20,7.8,20.4,8.2,21,8.2z"/>
				<path d="M4,18.6v-1.8c0-0.6-0.4-1-1-1c-0.6,0-1,0.4-1,1V21c0,0.6,0.4,1,1,1h4.2c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7
		c0-0.6-0.4-1-1-1H5.4l4.5-4.5L8.5,14L4,18.6z"/>
			</g>
		</SvgIcon>
	);
};

export const ErrorIcon = () => (<svg width="24" height="21" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M11.9998 8.00023V12.0002M11.9998 16.0002H12.0098M10.6151 2.89195L2.39019 17.0986C1.93398 17.8866 1.70588 18.2806 1.73959 18.6039C1.769 18.886 1.91677 19.1423 2.14613 19.309C2.40908 19.5002 2.86435 19.5002 3.77487 19.5002H20.2246C21.1352 19.5002 21.5904 19.5002 21.8534 19.309C22.0827 19.1423 22.2305 18.886 22.2599 18.6039C22.2936 18.2806 22.0655 17.8866 21.6093 17.0986L13.3844 2.89195C12.9299 2.10679 12.7026 1.71421 12.4061 1.58235C12.1474 1.46734 11.8521 1.46734 11.5935 1.58235C11.2969 1.71421 11.0696 2.10679 10.6151 2.89195Z" stroke="red" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);

export const InfoIcon = () => (<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M11 15V11M11 7H11.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z" stroke="#448FFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
)

export const NoteIcon = () => (<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M10 8.5V5M10 12H10.01M7.9 17.2L9.36 19.1467C9.57712 19.4362 9.68568 19.5809 9.81876 19.6327C9.93534 19.678 10.0647 19.678 10.1812 19.6327C10.3143 19.5809 10.4229 19.4362 10.64 19.1467L12.1 17.2C12.3931 16.8091 12.5397 16.6137 12.7185 16.4645C12.9569 16.2656 13.2383 16.1248 13.5405 16.0535C13.7671 16 14.0114 16 14.5 16C15.8978 16 16.5967 16 17.1481 15.7716C17.8831 15.4672 18.4672 14.8831 18.7716 14.1481C19 13.5967 19 12.8978 19 11.5V5.8C19 4.11984 19 3.27976 18.673 2.63803C18.3854 2.07354 17.9265 1.6146 17.362 1.32698C16.7202 1 15.8802 1 14.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V11.5C1 12.8978 1 13.5967 1.22836 14.1481C1.53284 14.8831 2.11687 15.4672 2.85195 15.7716C3.40326 16 4.10218 16 5.5 16C5.98858 16 6.23287 16 6.45951 16.0535C6.76169 16.1248 7.04312 16.2656 7.2815 16.4645C7.46028 16.6137 7.60685 16.8091 7.9 17.2Z" stroke="#FF9D66" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
)

export const WarningIcon = () => (<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M9 16.6586V19C9 20.1046 9.89543 21 11 21C12.1046 21 13 20.1046 13 19V16.6586M11 1V2M2 11H1M4.5 4.5L3.8999 3.8999M17.5 4.5L18.1002 3.8999M21 11H20M17 11C17 14.3137 14.3137 17 11 17C7.68629 17 5 14.3137 5 11C5 7.68629 7.68629 5 11 5C14.3137 5 17 7.68629 17 11Z" stroke="#F9C56D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
)
export const FilterIcon = props => (
	<SvgIcon {...props}>
			<path d="M2.38589 4.16687C1.62955 3.32155 1.25138 2.89889 1.23712 2.53968C1.22473 2.22764 1.35882 1.92772 1.59963 1.72889C1.87684 1.5 2.44399 1.5 3.57828 1.5H18.4212C19.5555 1.5 20.1227 1.5 20.3999 1.72889C20.6407 1.92772 20.7748 2.22764 20.7624 2.53968C20.7481 2.89889 20.3699 3.32155 19.6136 4.16687L13.9074 10.5444C13.7566 10.7129 13.6812 10.7972 13.6275 10.8931C13.5798 10.9781 13.5448 11.0697 13.5236 11.1648C13.4997 11.2721 13.4997 11.3852 13.4997 11.6113V16.9584C13.4997 17.1539 13.4997 17.2517 13.4682 17.3363C13.4403 17.411 13.395 17.4779 13.336 17.5315C13.2692 17.5922 13.1784 17.6285 12.9969 17.7012L9.59686 19.0612C9.22931 19.2082 9.04554 19.2817 8.89802 19.251C8.76901 19.2242 8.6558 19.1476 8.583 19.0377C8.49975 18.9122 8.49975 18.7142 8.49975 18.3184V11.6113C8.49975 11.3852 8.49975 11.2721 8.47587 11.1648C8.45469 11.0697 8.41971 10.9781 8.37204 10.8931C8.31828 10.7972 8.2429 10.7129 8.09213 10.5444L2.38589 4.16687Z" stroke="#448FFF" fill="none"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</SvgIcon>);

export const InpatientIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 -1340 1540 1540">
            <g transform="scale(1 -1)">
                <path d="M1357.505 723.376h-685.798v-183.193h868.991c0 103.339-84.55 183.193-183.193 183.193zM183.193 1024h-183.193v-1024h131.523l51.67 263.046h1169.615l51.67-263.046h131.523v446.239h-1352.807v577.761zM291.229 826.716h-14.092v-286.532h300.624c0 155.009-126.826 286.532-286.532 286.532z" />
            </g>
        </SvgIcon>
    );
};

export const ErrorIconHL7 = (props) => {
	return (
		<svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path d="M8.57732 1.06247L14.928 12.4062C14.9865 12.5107 15.0173 12.6293 15.0173 12.75C15.0173 12.8706 14.9865 12.9892 14.928 13.0937C14.8695 13.1982 14.7853 13.285 14.684 13.3454C14.5826 13.4057 14.4677 13.4375 14.3506 13.4375H1.64932C1.53229 13.4375 1.41733 13.4057 1.31599 13.3454C1.21464 13.285 1.13049 13.1982 1.07198 13.0937C1.01347 12.9892 0.982665 12.8706 0.982666 12.75C0.982667 12.6293 1.01347 12.5107 1.07198 12.4062L7.42265 1.06247C7.48116 0.957965 7.56532 0.871184 7.66666 0.810849C7.76801 0.750514 7.88296 0.71875 7.99998 0.71875C8.117 0.71875 8.23196 0.750514 8.3333 0.810849C8.43464 0.871184 8.5188 0.957965 8.57732 1.06247ZM7.33332 9.99997V11.375H8.66665V9.99997H7.33332ZM7.33332 5.18747V8.62497H8.66665V5.18747H7.33332Z" fill="#FF6868"/>
		</svg>
	)
}

export const ArrowIconHL7 = (props) => (
	<div style={{transform: props.open ? 'rotateX(180deg) translateY(19%)': "", transition: "all 0.5s ease-out", padding: 'auto',  textAlign: 'center', display: 'flex', alignItems: 'center'}}>
		<SvgIcon viewBox="0 0 15 10" {...props}>
			<path d="M5 5.5L0 0.5H10L5 5.5Z" fill={props.color}/>
		</SvgIcon>
	</div>
)

export const DatabaseIconHL7 = (props) => (<SvgIcon viewBox="0 0 18 21" {...props}>
		<path d="M2 4.5C2 4.52553 2.01022 4.66958 2.29209 4.91948C2.57279 5.16834 3.03602 5.43815 3.69427 5.68499C5.0034 6.17591 6.87903 6.5 9 6.5C11.121 6.5 12.9966 6.17591 14.3057 5.68499C14.964 5.43815 15.4272 5.16834 15.7079 4.91948C15.9898 4.66958 16 4.52553 16 4.5C16 4.47447 15.9898 4.33042 15.7079 4.08052C15.4272 3.83166 14.964 3.56185 14.3057 3.31501C12.9966 2.82409 11.121 2.5 9 2.5C6.87903 2.5 5.0034 2.82409 3.69427 3.31501C3.03602 3.56185 2.57279 3.83166 2.29209 4.08052C2.01022 4.33042 2 4.47447 2 4.5ZM0 4.5C0 3.69711 0.437492 3.05194 0.965273 2.58401C1.49422 2.11504 2.20256 1.7384 2.99202 1.44235C4.57833 0.847486 6.70269 0.5 9 0.5C11.2973 0.5 13.4217 0.847486 15.008 1.44235C15.7974 1.7384 16.5058 2.11504 17.0347 2.58401C17.5625 3.05194 18 3.69711 18 4.5V8.5V12.5V16.5C18 17.3029 17.5625 17.9481 17.0347 18.416C16.5058 18.885 15.7974 19.2616 15.008 19.5576C13.4217 20.1525 11.2973 20.5 9 20.5C6.70269 20.5 4.57833 20.1525 2.99202 19.5576C2.20256 19.2616 1.49422 18.885 0.965273 18.416C0.437492 17.9481 0 17.3029 0 16.5V12.5V8.5V4.5ZM2 8.5C2 8.52553 2.01022 8.66958 2.29209 8.91948C2.57279 9.16834 3.03602 9.43815 3.69427 9.68499C5.0034 10.1759 6.87903 10.5 9 10.5C11.121 10.5 12.9966 10.1759 14.3057 9.68499C14.964 9.43815 15.4272 9.16834 15.7079 8.91948C15.9898 8.66958 16 8.52553 16 8.5V7.11619C15.6909 7.27981 15.3574 7.42662 15.008 7.55765C13.4217 8.15251 11.2973 8.5 9 8.5C6.70269 8.5 4.57833 8.15251 2.99202 7.55765C2.64262 7.42662 2.3091 7.27981 2 7.11619V8.5ZM2 11.1162V12.5C2 12.5255 2.01022 12.6696 2.29209 12.9195C2.57279 13.1683 3.03602 13.4381 3.69427 13.685C5.0034 14.1759 6.87903 14.5 9 14.5C11.121 14.5 12.9966 14.1759 14.3057 13.685C14.964 13.4381 15.4272 13.1683 15.7079 12.9195C15.9898 12.6696 16 12.5255 16 12.5V11.1162C15.6909 11.2798 15.3574 11.4266 15.008 11.5576C13.4217 12.1525 11.2973 12.5 9 12.5C6.70269 12.5 4.57833 12.1525 2.99202 11.5576C2.64262 11.4266 2.3091 11.2798 2 11.1162ZM2 15.1162V16.5C2 16.5255 2.01022 16.6696 2.29209 16.9195C2.57279 17.1683 3.03602 17.4381 3.69427 17.685C5.0034 18.1759 6.87903 18.5 9 18.5C11.121 18.5 12.9966 18.1759 14.3057 17.685C14.964 17.4381 15.4272 17.1683 15.7079 16.9195C15.9898 16.6696 16 16.5255 16 16.5V15.1162C15.6909 15.2798 15.3574 15.4266 15.008 15.5576C13.4217 16.1525 11.2973 16.5 9 16.5C6.70269 16.5 4.57833 16.1525 2.99202 15.5576C2.64262 15.4266 2.3091 15.2798 2 15.1162Z" fill="#448FFF"/>
	</SvgIcon>
)

export const DateIconHL7 = (props) => (
	<SvgIcon viewBox="0 0 20 21"  {...props}>
		<path d="M0.243 6.35399L9.49 0.80999C9.64542 0.716739 9.82325 0.66748 10.0045 0.66748C10.1857 0.66748 10.3636 0.716739 10.519 0.80999L19.757 6.35499C19.8311 6.3994 19.8925 6.46227 19.9351 6.53746C19.9776 6.61264 20 6.69758 20 6.78399V19.5C20 19.7652 19.8946 20.0196 19.7071 20.2071C19.5196 20.3946 19.2652 20.5 19 20.5H1C0.734784 20.5 0.48043 20.3946 0.292893 20.2071C0.105357 20.0196 1.10073e-08 19.7652 1.10073e-08 19.5V6.78299C-1.81179e-05 6.69658 0.0223578 6.61164 0.0649455 6.53646C0.107533 6.46127 0.168879 6.3984 0.243 6.35399ZM2 7.63299V18.5H18V7.63199L10.004 2.83199L2 7.63199V7.63299ZM10.06 13.198L15.356 8.73499L16.644 10.265L10.074 15.802L3.364 10.272L4.636 8.72799L10.06 13.198Z" fill="#448FFF"/>
	</SvgIcon>
)

export const Bear = (props) => (
	<SvgIcon viewBox="0 0 24 24"  {...props}>
		<g>
			<g>
				<path id="Vector"
					  d="M7.82999 5.93023C7.63999 6.43023 7.51999 6.96023 7.51999 7.52023C7.51999 8.82023 8.07999 9.98023 8.96999 10.8002C8.90999 10.5602 8.86999 10.3002 8.86999 10.0402C8.86999 8.31023 10.27 6.91023 12 6.91023C13.73 6.91023 15.13 8.31023 15.13 10.0402C15.13 10.3002 15.09 10.5502 15.03 10.8002C15.92 9.98023 16.48 8.82023 16.48 7.52023C16.48 6.96023 16.36 6.42023 16.17 5.93023C17.17 5.83023 17.95 5.00023 17.95 3.97023C17.95 2.88023 17.07 1.99023 15.97 1.99023C15.02 1.99023 14.23 2.66023 14.04 3.55023C13.43 3.23023 12.74 3.04023 12 3.04023C11.26 3.04023 10.57 3.24023 9.95999 3.55023C9.76999 2.67023 8.97999 2.00023 8.02999 2.00023C6.93999 2.00023 6.04999 2.88023 6.04999 3.98023C6.04999 5.00023 6.82999 5.83023 7.82999 5.93023Z"
					  />
				<path id="Vector_2"
					  d="M11.28 8.25002C11.28 8.65002 11.6 8.97002 12 8.97002C12.4 8.97002 12.72 8.65002 12.72 8.25002C12.72 7.85002 12.4 7.52002 12 7.52002C11.6 7.52002 11.28 7.85002 11.28 8.25002Z"
					  />
				<path id="Vector_3"
					  d="M20.99 12.4403C20.8 11.3503 19.78 10.6303 18.68 10.8103L13.18 11.7503C12.8 11.7903 12.41 11.8303 12 11.8303C11.59 11.8303 11.21 11.7903 10.82 11.7503L5.32 10.8103C4.23 10.6303 3.2 11.3603 3.01 12.4403C2.82 13.5303 3.56 14.5603 4.64 14.7503L6.44 15.0603C6.36 15.4503 6.3 15.8403 6.3 16.2503C6.53 16.2003 6.76 16.1803 7 16.1803C7.72 16.1803 8.38 16.4103 8.93 16.7903C8.92 16.6903 8.9 16.5903 8.9 16.4803C8.9 16.1403 8.97 15.8203 9.07 15.5103C9.26 14.9303 9.62 14.4303 10.09 14.0503C10.12 14.0203 10.15 13.9903 10.19 13.9703C10.27 13.9103 10.35 13.8603 10.44 13.8103C10.52 13.7603 10.6 13.7203 10.68 13.6803C10.75 13.6403 10.83 13.6103 10.9 13.5803C11.01 13.5403 11.12 13.5003 11.24 13.4803C11.3 13.4603 11.37 13.4403 11.43 13.4303C11.61 13.4003 11.8 13.3703 12 13.3703C12.2 13.3703 12.38 13.3903 12.57 13.4303C12.63 13.4403 12.7 13.4603 12.76 13.4803C12.87 13.5103 12.99 13.5403 13.1 13.5803C13.18 13.6103 13.25 13.6403 13.32 13.6803C13.4 13.7203 13.48 13.7603 13.56 13.8103C13.64 13.8603 13.73 13.9103 13.81 13.9703C13.85 14.0003 13.88 14.0303 13.91 14.0503C14.38 14.4203 14.74 14.9203 14.93 15.5103C15.03 15.8203 15.1 16.1403 15.1 16.4803C15.1 16.5903 15.08 16.6903 15.07 16.7903C15.62 16.4103 16.28 16.1903 17 16.1903C17.24 16.1903 17.48 16.2203 17.7 16.2603C17.7 15.8503 17.64 15.4503 17.56 15.0603L19.36 14.7503C20.44 14.5703 21.17 13.5303 20.99 12.4403Z"
					  />
				<path id="Vector_4"
					  d="M7.00003 22.0002C8.33103 22.0002 9.41003 20.9212 9.41003 19.5902C9.41003 18.2592 8.33103 17.1802 7.00003 17.1802C5.66902 17.1802 4.59003 18.2592 4.59003 19.5902C4.59003 20.9212 5.66902 22.0002 7.00003 22.0002Z"
					 />
				<path id="Vector_5"
					  d="M17 17.1802C15.67 17.1802 14.59 18.2602 14.59 19.5902C14.59 19.7402 14.61 19.8902 14.63 20.0302C14.64 20.1002 14.67 20.1702 14.69 20.2502C14.71 20.3102 14.72 20.3702 14.74 20.4302C14.78 20.5302 14.82 20.6202 14.86 20.7102C14.87 20.7302 14.88 20.7602 14.9 20.7802C14.96 20.8802 15.02 20.9802 15.09 21.0702C15.54 21.6302 16.22 22.0002 17 22.0002C18.33 22.0002 19.41 20.9202 19.41 19.5902C19.41 18.2602 18.33 17.1802 17 17.1802Z"
					  />
				<path id="Vector_6"
					  d="M13.64 19.1001C13.16 19.4001 12.61 19.5801 12 19.5801C11.4 19.5801 10.84 19.4001 10.36 19.1001C10.38 19.2601 10.41 19.4201 10.41 19.5901C10.41 20.3201 10.18 20.9901 9.78998 21.5401C10.47 21.8301 11.22 21.9801 12 21.9801C12.78 21.9801 13.53 21.8201 14.2 21.5401C13.81 20.9901 13.58 20.3201 13.58 19.5901C13.59 19.4201 13.61 19.2601 13.64 19.1001Z"
					  />

			</g>
		</g>
	</SvgIcon>
)

export const EyonixGridA = (props) => (
	<SvgIcon  viewBox="0 0 610 610" {...props} >
		<path d="M518.2,91.8C461.2,34.9,385.5,3.5,305,3.5c-80.5,0-156.2,31.4-213.2,88.3S3.5,224.5,3.5,305c0,80.5,31.4,156.2,88.3,213.2  c56.9,56.9,132.7,88.3,213.2,88.3c80.5,0,156.2-31.4,213.2-88.3c56.9-56.9,88.3-132.7,88.3-213.2  C606.5,224.5,575.1,148.8,518.2,91.8z M305,6.5c79.2,0,153.7,30.7,210,86.4l-104,104c-27.3-26.8-64.8-43.4-106-43.4  c-41.2,0-78.7,16.6-106,43.4L95,92.9C151.3,37.2,225.8,6.5,305,6.5z M305,253.5c-13.7,0-26.1,5.4-35.3,14.1L201.1,199  c26.8-26.3,63.5-42.5,103.9-42.5c40.4,0,77.1,16.2,103.9,42.5l-68.6,68.6C331.1,258.9,318.7,253.5,305,253.5z M353.5,305  c0,26.7-21.8,48.5-48.5,48.5c-26.7,0-48.5-21.8-48.5-48.5s21.8-48.5,48.5-48.5C331.7,256.5,353.5,278.3,353.5,305z M267.6,269.7  c-8.7,9.2-14.1,21.7-14.1,35.3c0,13.7,5.4,26.1,14.1,35.3L199,408.9c-26.3-26.8-42.5-63.5-42.5-103.9c0-40.4,16.2-77.1,42.5-103.9  L267.6,269.7z M269.7,342.4c9.2,8.7,21.7,14.1,35.3,14.1c13.7,0,26.1-5.4,35.3-14.1l68.6,68.6c-26.8,26.3-63.5,42.5-103.9,42.5  c-40.4,0-77.1-16.2-103.9-42.5L269.7,342.4z M342.4,340.3c8.7-9.2,14.1-21.7,14.1-35.3c0-13.7-5.4-26.1-14.1-35.3l68.6-68.6  c26.3,26.8,42.5,63.5,42.5,103.9c0,40.4-16.2,77.1-42.5,103.9L342.4,340.3z M6.5,305c0-79.2,30.7-153.7,86.4-210l104,104  c-26.8,27.3-43.4,64.8-43.4,106c0,41.2,16.6,78.7,43.4,106l-104,104C37.2,458.7,6.5,384.2,6.5,305z M516.1,516.1  c-56.4,56.4-131.3,87.4-211.1,87.4c-79.2,0-153.7-30.7-210-86.4l104-104c27.3,26.8,64.8,43.4,106,43.4c41.2,0,78.7-16.6,106-43.4  L514.8,517l2.1-2.1L413.1,411c26.8-27.3,43.4-64.8,43.4-106c0-41.2-16.6-78.7-43.4-106l104-104c55.7,56.3,86.4,130.8,86.4,210  C603.5,384.7,572.5,459.7,516.1,516.1z"/>
	</SvgIcon>
)

export const EyonixGridB = (props) => (
	<SvgIcon  viewBox="0 0 610 610" {...props} >
		<g>
			<path d="M518.2,91.8C461.2,34.9,385.5,3.5,305,3.5c-80.5,0-156.2,31.4-213.2,88.3S3.5,224.5,3.5,305c0,80.5,31.4,156.2,88.3,213.2   c56.9,56.9,132.7,88.3,213.2,88.3c80.5,0,156.2-31.4,213.2-88.3c56.9-56.9,88.3-132.7,88.3-213.2   C606.5,224.5,575.1,148.8,518.2,91.8z M305,6.5c79.2,0,153.7,30.7,210,86.4l-104,104c-27.3-26.8-64.8-43.4-106-43.4   c-41.2,0-78.7,16.6-106,43.4L95,92.9C151.3,37.2,225.8,6.5,305,6.5z M305,253.5c-13.7,0-26.1,5.4-35.3,14.1L201.1,199   c26.8-26.3,63.5-42.5,103.9-42.5c40.4,0,77.1,16.2,103.9,42.5l-68.6,68.6C331.1,258.9,318.7,253.5,305,253.5z M353.5,305   c0,26.7-21.8,48.5-48.5,48.5s-48.5-21.8-48.5-48.5s21.8-48.5,48.5-48.5S353.5,278.3,353.5,305z M267.6,269.7   c-8.7,9.2-14.1,21.7-14.1,35.3c0,13.7,5.4,26.1,14.1,35.3L199,408.9c-26.3-26.8-42.5-63.5-42.5-103.9c0-40.4,16.2-77.1,42.5-103.9   L267.6,269.7z M269.7,342.4c9.2,8.7,21.7,14.1,35.3,14.1c13.7,0,26.1-5.4,35.3-14.1l68.6,68.6c-26.8,26.3-63.5,42.5-103.9,42.5   c-40.4,0-77.1-16.2-103.9-42.5L269.7,342.4z M342.4,340.3c8.7-9.2,14.1-21.7,14.1-35.3c0-13.7-5.4-26.1-14.1-35.3l68.6-68.6   c26.3,26.8,42.5,63.5,42.5,103.9c0,40.4-16.2,77.1-42.5,103.9L342.4,340.3z M6.5,305c0-79.2,30.7-153.7,86.4-210l104,104   c-26.8,27.3-43.4,64.8-43.4,106c0,41.2,16.6,78.7,43.4,106l-104,104C37.2,458.7,6.5,384.2,6.5,305z M516.1,516.1   c-56.4,56.4-131.3,87.4-211.1,87.4c-79.2,0-153.7-30.7-210-86.4l104-104c27.3,26.8,64.8,43.4,106,43.4c41.2,0,78.7-16.6,106-43.4   L514.8,517l2.1-2.1L413.1,411c26.8-27.3,43.4-64.8,43.4-106c0-41.2-16.6-78.7-43.4-106l104-104c55.7,56.3,86.4,130.8,86.4,210   C603.5,384.7,572.5,459.7,516.1,516.1z"/>
			<path  d="M304.3,311.8v-10.9l-3.6,1.3v-2.4l6.2-2.2h0.1v14.2H304.3z"/>
			<path d="M310,408.5v2.2h-1.7v3.1h-2.7v-3.1h-5.9l-0.1-1.7l6-9.4h2.8v8.9H310z M305.6,408.5v-5.3l-0.3,0.5l-3.1,4.8H305.6z"/>
			<path d="M309.1,529.4c-0.1,0.3-0.3,0.7-0.5,0.9c-0.2,0.2-0.4,0.4-0.6,0.6s-0.5,0.3-0.7,0.5c0.2,0.1,0.5,0.2,0.7,0.4     s0.4,0.3,0.6,0.5c0.3,0.3,0.6,0.7,0.7,1.1s0.3,0.9,0.3,1.4c0,0.7-0.1,1.3-0.4,1.8s-0.6,0.9-1,1.3c-0.4,0.3-0.9,0.6-1.5,0.8     s-1.2,0.3-1.9,0.3c-0.7,0-1.3-0.1-1.9-0.3s-1.1-0.4-1.5-0.8c-0.4-0.3-0.8-0.8-1-1.3s-0.4-1.1-0.4-1.8c0-0.4,0.1-0.8,0.2-1.1     s0.3-0.7,0.5-1c0.2-0.3,0.4-0.5,0.7-0.8s0.6-0.4,0.9-0.6c-0.3-0.1-0.6-0.3-0.8-0.5s-0.4-0.4-0.6-0.7c-0.2-0.3-0.3-0.6-0.4-0.9     s-0.1-0.7-0.1-1c0-0.6,0.1-1.2,0.3-1.7s0.5-0.9,0.9-1.2c0.4-0.3,0.9-0.6,1.4-0.8s1.1-0.3,1.8-0.3s1.2,0.1,1.8,0.3s1,0.4,1.4,0.8     c0.4,0.3,0.7,0.8,0.9,1.2s0.3,1.1,0.3,1.7C309.3,528.7,309.2,529.1,309.1,529.4z M306.7,533.8c-0.1-0.3-0.2-0.5-0.4-0.7     c-0.2-0.2-0.4-0.3-0.6-0.4s-0.5-0.1-0.8-0.1s-0.6,0-0.8,0.1s-0.5,0.2-0.6,0.4c-0.2,0.2-0.3,0.4-0.4,0.7s-0.1,0.6-0.1,0.9     c0,0.3,0.1,0.6,0.2,0.9s0.3,0.5,0.4,0.7c0.2,0.2,0.4,0.3,0.6,0.4s0.5,0.1,0.8,0.1c0.3,0,0.6,0,0.8-0.1s0.5-0.2,0.6-0.4     c0.2-0.2,0.3-0.4,0.4-0.7s0.2-0.5,0.2-0.9S306.8,534.1,306.7,533.8z M306.5,527.7c-0.1-0.2-0.2-0.4-0.4-0.6     c-0.2-0.2-0.3-0.3-0.6-0.4s-0.5-0.1-0.7-0.1c-0.3,0-0.5,0-0.7,0.1s-0.4,0.2-0.5,0.4c-0.1,0.2-0.3,0.4-0.3,0.6s-0.1,0.5-0.1,0.8     c0,0.3,0,0.5,0.1,0.8s0.2,0.4,0.4,0.6c0.1,0.2,0.3,0.3,0.6,0.4s0.5,0.1,0.7,0.1s0.5,0,0.7-0.1s0.4-0.2,0.5-0.4s0.3-0.4,0.3-0.6     s0.1-0.5,0.1-0.8S306.6,527.9,306.5,527.7z"/>
			<path d="M300,213.8v-1.9l4.6-4.9c0.4-0.4,0.7-0.7,0.9-1.1s0.4-0.6,0.6-0.9c0.1-0.3,0.3-0.5,0.3-0.7s0.1-0.4,0.1-0.7     c0-0.3,0-0.6-0.1-0.8s-0.2-0.5-0.4-0.6c-0.2-0.2-0.4-0.3-0.6-0.4s-0.5-0.1-0.8-0.1c-0.4,0-0.7,0.1-1,0.2s-0.5,0.2-0.7,0.4     c-0.2,0.2-0.3,0.5-0.4,0.8s-0.1,0.6-0.1,1h-2.7c0-0.6,0.1-1.2,0.4-1.8s0.6-1.1,1-1.5c0.4-0.4,1-0.8,1.6-1s1.3-0.4,2.1-0.4     c0.7,0,1.4,0.1,1.9,0.3s1,0.5,1.4,0.8c0.4,0.4,0.7,0.8,0.8,1.3s0.3,1.1,0.3,1.7c0,0.5-0.1,0.9-0.2,1.3s-0.4,0.8-0.6,1.3     c-0.3,0.4-0.6,0.8-1,1.3s-0.8,0.9-1.3,1.4l-2.7,2.8h6.2v2.2H300z"/>
			<path d="M307.6,76.7h-0.2c-0.7,0-1.3,0.1-1.9,0.3s-1,0.5-1.4,0.8c-0.4,0.3-0.7,0.8-0.9,1.2s-0.4,1-0.4,1.6     c0.1-0.2,0.3-0.3,0.5-0.5s0.4-0.3,0.7-0.4c0.2-0.1,0.5-0.2,0.8-0.3s0.6-0.1,0.9-0.1c0.7,0,1.3,0.1,1.8,0.4s0.9,0.6,1.3,1     c0.3,0.4,0.6,1,0.8,1.5s0.2,1.2,0.2,1.8c0,0.7-0.1,1.3-0.3,1.9s-0.5,1.1-0.9,1.5s-0.9,0.8-1.5,1s-1.2,0.4-2,0.4     c-0.8,0-1.4-0.1-2.1-0.4s-1.1-0.7-1.6-1.2c-0.4-0.5-0.8-1.1-1-1.8s-0.3-1.4-0.3-2.3v-1c0-1.1,0.2-2.2,0.5-3.1s0.8-1.8,1.4-2.5     c0.6-0.7,1.4-1.2,2.3-1.6s1.9-0.6,3.1-0.6h0.4V76.7z M304.2,81.6c-0.2,0.1-0.4,0.2-0.6,0.3c-0.2,0.1-0.3,0.3-0.4,0.4     s-0.2,0.3-0.3,0.5v0.8c0,0.5,0.1,1,0.2,1.4s0.3,0.7,0.5,1c0.2,0.3,0.4,0.5,0.7,0.6s0.6,0.2,0.9,0.2c0.3,0,0.6-0.1,0.9-0.2     s0.5-0.3,0.7-0.6s0.3-0.5,0.4-0.8s0.1-0.7,0.1-1.1s0-0.7-0.1-1.1s-0.2-0.6-0.4-0.8c-0.2-0.2-0.4-0.4-0.7-0.6s-0.6-0.2-0.9-0.2     C304.6,81.5,304.4,81.5,304.2,81.6z"/>
			<path d="M529.1,311.8h-2.9l5.5-12h-7.1v-2.2h10v1.5L529.1,311.8z"/>
			<path d="M404.6,303.5c0.4,0,0.7-0.1,1-0.2s0.5-0.3,0.7-0.5c0.2-0.2,0.3-0.4,0.4-0.6s0.1-0.5,0.1-0.8c0-0.3,0-0.5-0.1-0.8     s-0.2-0.4-0.4-0.6c-0.2-0.2-0.4-0.3-0.6-0.4s-0.5-0.1-0.9-0.1c-0.3,0-0.5,0-0.8,0.1s-0.4,0.2-0.6,0.3c-0.2,0.1-0.3,0.3-0.4,0.5     s-0.2,0.4-0.2,0.7h-2.7c0-0.6,0.1-1.1,0.4-1.6s0.6-0.9,1-1.2c0.4-0.3,0.9-0.6,1.5-0.8s1.2-0.3,1.8-0.3c0.7,0,1.3,0.1,1.9,0.3     s1.1,0.4,1.5,0.8c0.4,0.3,0.7,0.8,1,1.3s0.3,1.1,0.3,1.8c0,0.3,0,0.6-0.1,0.9s-0.2,0.6-0.4,0.8s-0.4,0.5-0.7,0.7     s-0.6,0.4-0.9,0.6c0.4,0.1,0.7,0.3,1,0.5s0.5,0.5,0.7,0.8c0.2,0.3,0.3,0.6,0.4,0.9s0.1,0.7,0.1,1.1c0,0.7-0.1,1.3-0.4,1.8     s-0.6,1-1,1.3c-0.4,0.4-1,0.6-1.6,0.8s-1.3,0.3-2,0.3c-0.6,0-1.2-0.1-1.8-0.2s-1.1-0.4-1.5-0.8c-0.4-0.3-0.8-0.8-1.1-1.3     s-0.4-1.1-0.4-1.8h2.7c0,0.3,0.1,0.5,0.2,0.8s0.3,0.4,0.4,0.6c0.2,0.2,0.4,0.3,0.7,0.4s0.5,0.1,0.9,0.1c0.4,0,0.7,0,0.9-0.1     s0.5-0.2,0.7-0.4c0.2-0.2,0.3-0.4,0.4-0.6s0.1-0.5,0.1-0.8c0-0.4-0.1-0.7-0.2-1s-0.3-0.5-0.5-0.7c-0.2-0.2-0.5-0.3-0.8-0.4     s-0.6-0.1-1-0.1h-1.5v-2.1H404.6z"/>
			<path d="M201.3,297.5h7.9v2.3h-5.7l-0.3,3.1c0.2-0.1,0.5-0.2,0.9-0.4s0.8-0.2,1.3-0.2c0.7,0,1.3,0.1,1.8,0.3s1,0.5,1.4,0.9     c0.4,0.4,0.6,0.9,0.8,1.5s0.3,1.3,0.3,2c0,0.6-0.1,1.2-0.3,1.8s-0.5,1.1-0.9,1.5s-0.9,0.8-1.5,1s-1.3,0.4-2.1,0.4     c-0.6,0-1.2-0.1-1.8-0.3s-1.1-0.4-1.5-0.8s-0.8-0.8-1.1-1.3s-0.4-1.1-0.4-1.8h2.7c0.1,0.6,0.3,1.1,0.7,1.4s0.9,0.5,1.5,0.5     c0.4,0,0.7-0.1,0.9-0.2s0.5-0.3,0.6-0.6c0.2-0.2,0.3-0.5,0.3-0.9s0.1-0.7,0.1-1.1c0-0.4,0-0.7-0.1-1s-0.2-0.6-0.4-0.8     s-0.4-0.4-0.7-0.5s-0.6-0.2-1-0.2c-0.3,0-0.5,0-0.7,0.1s-0.4,0.1-0.5,0.2s-0.3,0.2-0.4,0.2s-0.2,0.2-0.3,0.3l-2.2-0.5     L201.3,297.5z"/>
			<path d="M79.1,309.4c0.5-0.2,1-0.4,1.3-0.7c0.4-0.3,0.6-0.6,0.8-1.1s0.3-0.9,0.4-1.4v-0.1c-0.1,0.1-0.3,0.3-0.5,0.4     s-0.4,0.2-0.6,0.3c-0.2,0.1-0.5,0.2-0.7,0.2s-0.6,0.1-0.9,0.1c-0.7,0-1.3-0.1-1.8-0.4s-0.9-0.6-1.3-1c-0.4-0.4-0.6-0.9-0.8-1.5     s-0.3-1.2-0.3-1.9c0-0.7,0.1-1.3,0.3-1.9s0.5-1.1,0.9-1.6s0.9-0.8,1.5-1.1s1.2-0.4,2-0.4c0.7,0,1.4,0.1,2,0.4s1.1,0.7,1.5,1.2     c0.4,0.5,0.7,1.1,0.9,1.8s0.3,1.5,0.3,2.3v0.9c0,1.1-0.1,2.2-0.4,3.1s-0.7,1.8-1.3,2.5c-0.6,0.7-1.3,1.2-2.2,1.6s-2,0.6-3.2,0.6     h-0.2v-2.3h0.2C78,309.6,78.6,309.5,79.1,309.4z M80.4,305c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.3-0.3,0.4-0.4s0.2-0.4,0.3-0.6v-1     c0-0.5-0.1-1-0.2-1.4s-0.3-0.7-0.4-1s-0.4-0.5-0.7-0.6s-0.5-0.2-0.8-0.2c-0.3,0-0.6,0.1-0.9,0.2s-0.5,0.4-0.6,0.6     c-0.2,0.3-0.3,0.6-0.4,0.9s-0.1,0.7-0.1,1s0,0.7,0.1,1s0.2,0.6,0.4,0.9c0.2,0.2,0.4,0.4,0.6,0.6s0.6,0.2,0.9,0.2     C80,305.1,80.2,305,80.4,305z"/>
		</g>
	</SvgIcon>
)

export const EyonixGridC = (props) => (
	<SvgIcon  viewBox="0 0 610 610" {...props} >
	<g>
	<path d="M518.2,91.8C461.2,34.9,385.5,3.5,305,3.5c-80.5,0-156.2,31.4-213.2,88.3S3.5,224.5,3.5,305c0,80.5,31.4,156.2,88.3,213.2   c56.9,56.9,132.7,88.3,213.2,88.3c80.5,0,156.2-31.4,213.2-88.3c56.9-56.9,88.3-132.7,88.3-213.2   C606.5,224.5,575.1,148.8,518.2,91.8z M305,6.5c79.2,0,153.7,30.7,210,86.4l-104,104c-27.3-26.8-64.8-43.4-106-43.4   c-41.2,0-78.7,16.6-106,43.4L95,92.9C151.3,37.2,225.8,6.5,305,6.5z M305,253.5c-13.7,0-26.1,5.4-35.3,14.1L201.1,199   c26.8-26.3,63.5-42.5,103.9-42.5c40.4,0,77.1,16.2,103.9,42.5l-68.6,68.6C331.1,258.9,318.7,253.5,305,253.5z M353.5,305   c0,26.7-21.8,48.5-48.5,48.5s-48.5-21.8-48.5-48.5s21.8-48.5,48.5-48.5S353.5,278.3,353.5,305z M267.6,269.7   c-8.7,9.2-14.1,21.7-14.1,35.3c0,13.7,5.4,26.1,14.1,35.3L199,408.9c-26.3-26.8-42.5-63.5-42.5-103.9c0-40.4,16.2-77.1,42.5-103.9   L267.6,269.7z M269.7,342.4c9.2,8.7,21.7,14.1,35.3,14.1c13.7,0,26.1-5.4,35.3-14.1l68.6,68.6c-26.8,26.3-63.5,42.5-103.9,42.5   c-40.4,0-77.1-16.2-103.9-42.5L269.7,342.4z M342.4,340.3c8.7-9.2,14.1-21.7,14.1-35.3c0-13.7-5.4-26.1-14.1-35.3l68.6-68.6   c26.3,26.8,42.5,63.5,42.5,103.9c0,40.4-16.2,77.1-42.5,103.9L342.4,340.3z M6.5,305c0-79.2,30.7-153.7,86.4-210l104,104   c-26.8,27.3-43.4,64.8-43.4,106c0,41.2,16.6,78.7,43.4,106l-104,104C37.2,458.7,6.5,384.2,6.5,305z M516.1,516.1   c-56.4,56.4-131.3,87.4-211.1,87.4c-79.2,0-153.7-30.7-210-86.4l104-104c27.3,26.8,64.8,43.4,106,43.4c41.2,0,78.7-16.6,106-43.4   L514.8,517l2.1-2.1L413.1,411c26.8-27.3,43.4-64.8,43.4-106c0-41.2-16.6-78.7-43.4-106l104-104c55.7,56.3,86.4,130.8,86.4,210   C603.5,384.7,572.5,459.7,516.1,516.1z"/>
		<path d="M304.3,311.8v-10.9l-3.6,1.3v-2.4l6.2-2.2h0.1v14.2H304.3z"/>
		<path d="M310,408.5v2.2h-1.7v3.1h-2.7v-3.1h-5.9l-0.1-1.7l6-9.4h2.8v8.9H310z M305.6,408.5v-5.3l-0.3,0.5l-3.1,4.8H305.6z"/>
		<path d="M309.1,529.4c-0.1,0.3-0.3,0.7-0.5,0.9c-0.2,0.2-0.4,0.4-0.6,0.6s-0.5,0.3-0.7,0.5c0.2,0.1,0.5,0.2,0.7,0.4     s0.4,0.3,0.6,0.5c0.3,0.3,0.6,0.7,0.7,1.1s0.3,0.9,0.3,1.4c0,0.7-0.1,1.3-0.4,1.8s-0.6,0.9-1,1.3c-0.4,0.3-0.9,0.6-1.5,0.8     s-1.2,0.3-1.9,0.3c-0.7,0-1.3-0.1-1.9-0.3s-1.1-0.4-1.5-0.8c-0.4-0.3-0.8-0.8-1-1.3s-0.4-1.1-0.4-1.8c0-0.4,0.1-0.8,0.2-1.1     s0.3-0.7,0.5-1c0.2-0.3,0.4-0.5,0.7-0.8s0.6-0.4,0.9-0.6c-0.3-0.1-0.6-0.3-0.8-0.5s-0.4-0.4-0.6-0.7c-0.2-0.3-0.3-0.6-0.4-0.9     s-0.1-0.7-0.1-1c0-0.6,0.1-1.2,0.3-1.7s0.5-0.9,0.9-1.2c0.4-0.3,0.9-0.6,1.4-0.8s1.1-0.3,1.8-0.3s1.2,0.1,1.8,0.3s1,0.4,1.4,0.8     c0.4,0.3,0.7,0.8,0.9,1.2s0.3,1.1,0.3,1.7C309.3,528.7,309.2,529.1,309.1,529.4z M306.7,533.8c-0.1-0.3-0.2-0.5-0.4-0.7     c-0.2-0.2-0.4-0.3-0.6-0.4s-0.5-0.1-0.8-0.1s-0.6,0-0.8,0.1s-0.5,0.2-0.6,0.4c-0.2,0.2-0.3,0.4-0.4,0.7s-0.1,0.6-0.1,0.9     c0,0.3,0.1,0.6,0.2,0.9s0.3,0.5,0.4,0.7c0.2,0.2,0.4,0.3,0.6,0.4s0.5,0.1,0.8,0.1c0.3,0,0.6,0,0.8-0.1s0.5-0.2,0.6-0.4     c0.2-0.2,0.3-0.4,0.4-0.7s0.2-0.5,0.2-0.9S306.8,534.1,306.7,533.8z M306.5,527.7c-0.1-0.2-0.2-0.4-0.4-0.6     c-0.2-0.2-0.3-0.3-0.6-0.4s-0.5-0.1-0.7-0.1c-0.3,0-0.5,0-0.7,0.1s-0.4,0.2-0.5,0.4c-0.1,0.2-0.3,0.4-0.3,0.6s-0.1,0.5-0.1,0.8     c0,0.3,0,0.5,0.1,0.8s0.2,0.4,0.4,0.6c0.1,0.2,0.3,0.3,0.6,0.4s0.5,0.1,0.7,0.1s0.5,0,0.7-0.1s0.4-0.2,0.5-0.4s0.3-0.4,0.3-0.6     s0.1-0.5,0.1-0.8S306.6,527.9,306.5,527.7z"/>
		<path d="M300,213.8v-1.9l4.6-4.9c0.4-0.4,0.7-0.7,0.9-1.1s0.4-0.6,0.6-0.9c0.1-0.3,0.3-0.5,0.3-0.7s0.1-0.4,0.1-0.7     c0-0.3,0-0.6-0.1-0.8s-0.2-0.5-0.4-0.6c-0.2-0.2-0.4-0.3-0.6-0.4s-0.5-0.1-0.8-0.1c-0.4,0-0.7,0.1-1,0.2s-0.5,0.2-0.7,0.4     c-0.2,0.2-0.3,0.5-0.4,0.8s-0.1,0.6-0.1,1h-2.7c0-0.6,0.1-1.2,0.4-1.8s0.6-1.1,1-1.5c0.4-0.4,1-0.8,1.6-1s1.3-0.4,2.1-0.4     c0.7,0,1.4,0.1,1.9,0.3s1,0.5,1.4,0.8c0.4,0.4,0.7,0.8,0.8,1.3s0.3,1.1,0.3,1.7c0,0.5-0.1,0.9-0.2,1.3s-0.4,0.8-0.6,1.3     c-0.3,0.4-0.6,0.8-1,1.3s-0.8,0.9-1.3,1.4l-2.7,2.8h6.2v2.2H300z"/>
		<path d="M307.6,76.7h-0.2c-0.7,0-1.3,0.1-1.9,0.3s-1,0.5-1.4,0.8c-0.4,0.3-0.7,0.8-0.9,1.2s-0.4,1-0.4,1.6     c0.1-0.2,0.3-0.3,0.5-0.5s0.4-0.3,0.7-0.4c0.2-0.1,0.5-0.2,0.8-0.3s0.6-0.1,0.9-0.1c0.7,0,1.3,0.1,1.8,0.4s0.9,0.6,1.3,1     c0.3,0.4,0.6,1,0.8,1.5s0.2,1.2,0.2,1.8c0,0.7-0.1,1.3-0.3,1.9s-0.5,1.1-0.9,1.5s-0.9,0.8-1.5,1s-1.2,0.4-2,0.4     c-0.8,0-1.4-0.1-2.1-0.4s-1.1-0.7-1.6-1.2c-0.4-0.5-0.8-1.1-1-1.8s-0.3-1.4-0.3-2.3v-1c0-1.1,0.2-2.2,0.5-3.1s0.8-1.8,1.4-2.5     c0.6-0.7,1.4-1.2,2.3-1.6s1.9-0.6,3.1-0.6h0.4V76.7z M304.2,81.6c-0.2,0.1-0.4,0.2-0.6,0.3c-0.2,0.1-0.3,0.3-0.4,0.4     s-0.2,0.3-0.3,0.5v0.8c0,0.5,0.1,1,0.2,1.4s0.3,0.7,0.5,1c0.2,0.3,0.4,0.5,0.7,0.6s0.6,0.2,0.9,0.2c0.3,0,0.6-0.1,0.9-0.2     s0.5-0.3,0.7-0.6s0.3-0.5,0.4-0.8s0.1-0.7,0.1-1.1s0-0.7-0.1-1.1s-0.2-0.6-0.4-0.8c-0.2-0.2-0.4-0.4-0.7-0.6s-0.6-0.2-0.9-0.2     C304.6,81.5,304.4,81.5,304.2,81.6z"/>
		<path d="M529.1,309.4c0.5-0.2,1-0.4,1.3-0.7c0.4-0.3,0.6-0.6,0.8-1.1s0.3-0.9,0.4-1.4v-0.1c-0.1,0.1-0.3,0.3-0.5,0.4     s-0.4,0.2-0.6,0.3c-0.2,0.1-0.5,0.2-0.7,0.2s-0.6,0.1-0.9,0.1c-0.7,0-1.3-0.1-1.8-0.4s-0.9-0.6-1.3-1c-0.4-0.4-0.6-0.9-0.8-1.5     s-0.3-1.2-0.3-1.9c0-0.7,0.1-1.3,0.3-1.9s0.5-1.1,0.9-1.6s0.9-0.8,1.5-1.1s1.2-0.4,2-0.4c0.7,0,1.4,0.1,2,0.4s1.1,0.7,1.5,1.2     c0.4,0.5,0.7,1.1,0.9,1.8s0.3,1.5,0.3,2.3v0.9c0,1.1-0.1,2.2-0.4,3.1s-0.7,1.8-1.3,2.5c-0.6,0.7-1.3,1.2-2.2,1.6s-2,0.6-3.2,0.6     h-0.2v-2.3h0.2C528,309.6,528.6,309.5,529.1,309.4z M530.4,305c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.3-0.3,0.4-0.4s0.2-0.4,0.3-0.6     v-1c0-0.5-0.1-1-0.2-1.4s-0.3-0.7-0.4-1s-0.4-0.5-0.7-0.6s-0.5-0.2-0.8-0.2c-0.3,0-0.6,0.1-0.9,0.2s-0.5,0.4-0.6,0.6     c-0.2,0.3-0.3,0.6-0.4,0.9s-0.1,0.7-0.1,1s0,0.7,0.1,1s0.2,0.6,0.4,0.9c0.2,0.2,0.4,0.4,0.6,0.6s0.6,0.2,0.9,0.2     C530,305.1,530.2,305,530.4,305z"/>
		<path d="M401.3,297.5h7.9v2.3h-5.7l-0.3,3.1c0.2-0.1,0.5-0.2,0.9-0.4s0.8-0.2,1.3-0.2c0.7,0,1.3,0.1,1.8,0.3s1,0.5,1.4,0.9     c0.4,0.4,0.6,0.9,0.8,1.5s0.3,1.3,0.3,2c0,0.6-0.1,1.2-0.3,1.8s-0.5,1.1-0.9,1.5s-0.9,0.8-1.5,1s-1.3,0.4-2.1,0.4     c-0.6,0-1.2-0.1-1.8-0.3s-1.1-0.4-1.5-0.8s-0.8-0.8-1.1-1.3s-0.4-1.1-0.4-1.8h2.7c0.1,0.6,0.3,1.1,0.7,1.4s0.9,0.5,1.5,0.5     c0.4,0,0.7-0.1,0.9-0.2s0.5-0.3,0.6-0.6c0.2-0.2,0.3-0.5,0.3-0.9s0.1-0.7,0.1-1.1c0-0.4,0-0.7-0.1-1s-0.2-0.6-0.4-0.8     s-0.4-0.4-0.7-0.5s-0.6-0.2-1-0.2c-0.3,0-0.5,0-0.7,0.1s-0.4,0.1-0.5,0.2s-0.3,0.2-0.4,0.2s-0.2,0.2-0.3,0.3l-2.2-0.5     L401.3,297.5z"/>
		<path d="M204.6,303.5c0.4,0,0.7-0.1,1-0.2s0.5-0.3,0.7-0.5c0.2-0.2,0.3-0.4,0.4-0.6s0.1-0.5,0.1-0.8c0-0.3,0-0.5-0.1-0.8     s-0.2-0.4-0.4-0.6c-0.2-0.2-0.4-0.3-0.6-0.4s-0.5-0.1-0.9-0.1c-0.3,0-0.5,0-0.8,0.1s-0.4,0.2-0.6,0.3c-0.2,0.1-0.3,0.3-0.4,0.5     s-0.2,0.4-0.2,0.7h-2.7c0-0.6,0.1-1.1,0.4-1.6s0.6-0.9,1-1.2c0.4-0.3,0.9-0.6,1.5-0.8s1.2-0.3,1.8-0.3c0.7,0,1.3,0.1,1.9,0.3     s1.1,0.4,1.5,0.8c0.4,0.3,0.7,0.8,1,1.3s0.3,1.1,0.3,1.8c0,0.3,0,0.6-0.1,0.9s-0.2,0.6-0.4,0.8s-0.4,0.5-0.7,0.7     s-0.6,0.4-0.9,0.6c0.4,0.1,0.7,0.3,1,0.5s0.5,0.5,0.7,0.8c0.2,0.3,0.3,0.6,0.4,0.9s0.1,0.7,0.1,1.1c0,0.7-0.1,1.3-0.4,1.8     s-0.6,1-1,1.3c-0.4,0.4-1,0.6-1.6,0.8s-1.3,0.3-2,0.3c-0.6,0-1.2-0.1-1.8-0.2s-1.1-0.4-1.5-0.8c-0.4-0.3-0.8-0.8-1.1-1.3     s-0.4-1.1-0.4-1.8h2.7c0,0.3,0.1,0.5,0.2,0.8s0.3,0.4,0.4,0.6c0.2,0.2,0.4,0.3,0.7,0.4s0.5,0.1,0.9,0.1c0.4,0,0.7,0,0.9-0.1     s0.5-0.2,0.7-0.4c0.2-0.2,0.3-0.4,0.4-0.6s0.1-0.5,0.1-0.8c0-0.4-0.1-0.7-0.2-1s-0.3-0.5-0.5-0.7c-0.2-0.2-0.5-0.3-0.8-0.4     s-0.6-0.1-1-0.1h-1.5v-2.1H204.6z"/>
		<path d="M79.1,311.8h-2.9l5.5-12h-7.1v-2.2h10v1.5L79.1,311.8z"/>
	</g>
	</SvgIcon>
)

export const FilterIcon2 = () => {
	return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<g>
			<path d="M17.5 20.5C16.5333 20.5 15.7083 20.1583 15.025 19.475C14.3417 18.7917 14 17.9667 14 17C14 16.0333 14.3417 15.2083 15.025 14.525C15.7083 13.8417 16.5333 13.5 17.5 13.5C18.4667 13.5 19.2917 13.8417 19.975 14.525C20.6583 15.2083 21 16.0333 21 17C21 17.9667 20.6583 18.7917 19.975 19.475C19.2917 20.1583 18.4667 20.5 17.5 20.5ZM17.5 18.5C17.9167 18.5 18.2708 18.3542 18.5625 18.0625C18.8542 17.7708 19 17.4167 19 17C19 16.5833 18.8542 16.2292 18.5625 15.9375C18.2708 15.6458 17.9167 15.5 17.5 15.5C17.0833 15.5 16.7292 15.6458 16.4375 15.9375C16.1458 16.2292 16 16.5833 16 17C16 17.4167 16.1458 17.7708 16.4375 18.0625C16.7292 18.3542 17.0833 18.5 17.5 18.5ZM3 18V16H12V18H3ZM6.5 10.5C5.53333 10.5 4.70833 10.1583 4.025 9.475C3.34167 8.79167 3 7.96667 3 7C3 6.03333 3.34167 5.20833 4.025 4.525C4.70833 3.84167 5.53333 3.5 6.5 3.5C7.46667 3.5 8.29167 3.84167 8.975 4.525C9.65833 5.20833 10 6.03333 10 7C10 7.96667 9.65833 8.79167 8.975 9.475C8.29167 10.1583 7.46667 10.5 6.5 10.5ZM6.5 8.5C6.91667 8.5 7.27083 8.35417 7.5625 8.0625C7.85417 7.77083 8 7.41667 8 7C8 6.58333 7.85417 6.22917 7.5625 5.9375C7.27083 5.64583 6.91667 5.5 6.5 5.5C6.08333 5.5 5.72917 5.64583 5.4375 5.9375C5.14583 6.22917 5 6.58333 5 7C5 7.41667 5.14583 7.77083 5.4375 8.0625C5.72917 8.35417 6.08333 8.5 6.5 8.5ZM12 8V6H21V8H12Z" fill="white"/>
		</g>
	</svg>
}

export const SmartViewIcon = (props) => {
	return <SvgIcon  viewBox="0 0 24 24" {...props} >

	<g>
		<path d="M21.9,11.5C21.7,11.2,17.5,4,12,4c-5.5,0-9.7,7.2-9.9,7.5c-0.2,0.3-0.2,0.7,0,1C2.3,12.8,6.5,20,12,20   c5.5,0,9.7-7.2,9.9-7.5C22,12.2,22,11.8,21.9,11.5z M12,18c-3.6,0-6.8-4.5-7.8-6c1.3-2,4.5-6,7.8-6c3.6,0,6.8,4.5,7.8,6   C18.5,14.1,15.3,18,12,18z"/>
		<path d="M12,7.6c-2.4,0-4.4,2-4.4,4.4c0,2.4,2,4.4,4.4,4.4c2.4,0,4.4-2,4.4-4.4C16.4,9.6,14.4,7.6,12,7.6z M12,14.6   c-1.4,0-2.6-1.2-2.6-2.6s1.2-2.6,2.6-2.6s2.6,1.2,2.6,2.6S13.4,14.6,12,14.6z"/>
	</g>

	</SvgIcon>
}


export const AppIcon = (props) => {
	return  <SvgIcon  viewBox="0 0 24 24" {...props} >
		<g id="Layer_5" >
			<g>
				<path d="M20,12v7c0,0.6-0.4,1-1,1H5c-0.6,0-1-0.4-1-1V5c0-0.6,0.4-1,1-1h7V2H5C3.3,2,2,3.3,2,5v14c0,1.7,1.3,3,3,3h14    c1.7,0,3-1.3,3-3v-7H20z"/>
				<polygon points="15.6,7 12,10.6 10.7,11.9 12.1,13.3 13.4,12 17,8.4 20,5.4 20,9 22,9 22,2 15,2 15,4 18.6,4   "/>
			</g>
		</g>
	</SvgIcon>
}

export const SaveIcon2 = () => {
	return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path d="M16.8 4H7.2H5.6C4.72 4 4 4.72 4 5.6V18.4C4 19.288 4.72 20 5.6 20H7.192H16.792H18.4C19.288 20 20 19.288 20 18.4V7.2L16.8 4ZM15.2 5.6V7.2H11.2V5.6H15.2ZM9.6 5.6V7.2H8.8V5.6H9.6ZM8.792 18.4V12.8H15.192V18.4H8.792ZM18.4 18.4H16.792V11.2H7.192V18.4H5.6V5.6H7.2V8.8H16.8V6.264L18.4 7.864V18.4Z" fill="#D2D5D9"/>
	</svg>
}

export const FilterIcon3 = () => {
	return <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
		<path d="M15.9915 8.26667C15.5211 6.94973 14.2756 6 12.8 6C11.3244 6 10.0789 6.94973 9.60853 8.26667H6V10.5333H9.60967C10.0789 11.8503 11.3244 12.8 12.8 12.8C14.2756 12.8 15.5211 11.8503 15.9915 10.5333H28.6667V8.26667H15.9915ZM12.8 10.5333C12.1755 10.5333 11.6667 10.0245 11.6667 9.4C11.6667 8.77553 12.1755 8.26667 12.8 8.26667C13.4245 8.26667 13.9333 8.77553 13.9333 9.4C13.9333 10.0245 13.4245 10.5333 12.8 10.5333Z" fill="white"/>
		<path d="M12.8 21.8662C11.3244 21.8662 10.0789 22.8171 9.60853 24.1329H6V26.3995H9.60967C10.0789 27.7153 11.3244 28.6662 12.8 28.6662C14.2756 28.6662 15.5211 27.7153 15.9915 26.3995H28.6667V24.1329H15.9915C15.5211 22.8171 14.2756 21.8662 12.8 21.8662ZM12.8 26.3995C12.1755 26.3995 11.6667 25.8918 11.6667 25.2662C11.6667 24.6406 12.1755 24.1329 12.8 24.1329C13.4245 24.1329 13.9333 24.6406 13.9333 25.2662C13.9333 25.8918 13.4245 26.3995 12.8 26.3995Z" fill="white"/>
		<path d="M21.8667 13.9326C20.3911 13.9326 19.1455 14.8824 18.6763 16.1993H6V18.466H18.6763C19.1455 19.7817 20.3922 20.7326 21.8667 20.7326C23.3411 20.7326 24.5878 19.7817 25.057 18.466H28.6667V16.1993H25.057C24.5878 14.8824 23.3423 13.9326 21.8667 13.9326ZM21.8667 18.466C21.2411 18.466 20.7333 17.9571 20.7333 17.3326C20.7333 16.7082 21.2411 16.1993 21.8667 16.1993C22.4923 16.1993 23 16.7082 23 17.3326C23 17.9571 22.4923 18.466 21.8667 18.466Z" fill="white"/>
	</svg>
}


export const StudyListIcon = () => {
	return <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
		<path d="M9 5H5V9H9V5Z" fill="white"/>
		<path d="M25 5H11V9H25V5Z" fill="white"/>
		<path d="M9 13H5V17H9V13Z" fill="white"/>
		<path d="M25 13H11V17H25V13Z" fill="white"/>
		<path d="M9 21H5V25H9V21Z" fill="white"/>
		<path d="M25 21H11V25H25V21Z" fill="white"/>
	</svg>
}

export const StudyListIcon2 = () => {
	return   <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
		<path d="M13 5H6C5.4 5 5 5.4 5 6V13C5 13.6 5.4 14 6 14H13C13.6 14 14 13.6 14 13V6C14 5.4 13.6 5 13 5ZM12 12H7V7H12V12Z" fill="white"/>
		<path d="M24 5H17C16.4 5 16 5.4 16 6V13C16 13.6 16.4 14 17 14H24C24.6 14 25 13.6 25 13V6C25 5.4 24.6 5 24 5ZM23 12H18V7H23V12Z" fill="white"/>
		<path d="M13 16H6C5.4 16 5 16.4 5 17V24C5 24.6 5.4 25 6 25H13C13.6 25 14 24.6 14 24V17C14 16.4 13.6 16 13 16ZM12 23H7V18H12V23Z" fill="white"/>
		<path d="M24 16H17C16.4 16 16 16.4 16 17V24C16 24.6 16.4 25 17 25H24C24.6 25 25 24.6 25 24V17C25 16.4 24.6 16 24 16ZM23 23H18V18H23V23Z" fill="white"/>
	</svg>


}

export const FinalAnnotationIcon = (props) => {
	return <SvgIcon  viewBox="0 0 18 18" {...props} >

		<g>
			<path d="M14.4 14.4H1.6V1.6H9.6V0H0.8C0.32 0 0 0.32 0 0.8V15.2C0 15.68 0.32 16 0.8 16H15.2C15.68 16 16 15.68 16 15.2V6.4H14.4V14.4Z"/>
			<path d="M3.9198 7.20004L2.7998 8.32004L5.9998 11.44C6.1598 11.6 6.3198 11.68 6.5598 11.68C6.5598 11.68 6.5598 11.68 6.6398 11.68C6.87981 11.68 7.0398 11.6 7.1998 11.36L11.2798 6.40004L13.2798 4.08004L12.0798 3.04004L9.5998 5.92004L6.4798 9.68004L3.9198 7.20004Z" />
		</g>
		<defs>
			<clipPath id="clip0_432_3875">
				<rect width="24" height="24" fill="white"/>
			</clipPath>
		</defs>

	</SvgIcon>
}

export const BinIcon = (props) => {
	return <SvgIcon  viewBox="0 0 20 20" {...props} >


		<path d="M12 6H10V16H12V6Z" fill="white"/>
		<path d="M9 6H7V16H9V6Z" fill="white"/>
		<path d="M6 6H4V16H6V6Z" fill="white"/>
		<path d="M11.86 20H4.14C2.41 20 1 18.43 1 16.5V4H0V2H6V0H10V2H16V4H15V16.5C15 18.43 13.59 20 11.86 20ZM4.14 18H11.86C12.48 18 13 17.31 13 16.5V4H3V16.5C3 17.31 3.53 18 4.14 18Z" fill="white"/>

	</SvgIcon>
}


export const Glass1Icon = (props) => {
	return <SvgIcon  viewBox="0 0 68 93" {...props} >
		<path d="M55.52 88.66L65.06 28.7L55.25 90.34L55.52 88.66Z" />
		<path d="M67.13 0H0.869995V28.43L11.04 92.34H56.95L67.12 28.43V0H67.13ZM14.46 88.35L4.87 28.12V4H63.13V28.12L53.54 88.35H14.46Z" />
		<path d="M10.98 41.0703L17.87 84.3503H50.13L57.02 41.0703H10.98Z" />

	</SvgIcon>
}

export const Glass2Icon = (props) => {
	return <SvgIcon  viewBox="0 0 64 75" {...props} >
		<path d="M31.8701 42.3398V72.9998"   strokeWidth="4" stroke-miterlimit="10"/>
		<path d="M47.66 73H16.08"   strokeWidth="4" stroke-miterlimit="10"/>
		<path d="M32 44.3403C14.44 44.3403 0.160034 29.0803 0.160034 10.3203C0.160034 7.66031 0.460039 4.99031 1.04004 2.38031L1.39003 0.820312H62.61L62.96 2.38031C63.54 4.99031 63.84 7.66031 63.84 10.3203C63.84 29.0803 49.56 44.3403 32 44.3403ZM4.63004 4.82031C4.32004 6.64031 4.16003 8.48031 4.16003 10.3203C4.16003 26.8703 16.65 40.3403 32 40.3403C47.35 40.3403 59.84 26.8703 59.84 10.3203C59.84 8.48031 59.68 6.64031 59.37 4.82031H4.63004Z" />
		<path d="M32 36.3398C44.15 36.3398 54.21 26.3598 55.66 13.5098H8.35004C9.80004 26.3598 19.85 36.3398 32.01 36.3398H32Z" />
		<path d="M59.68 13.5195C58.2 28.5795 46.35 40.3495 32 40.3495C17.65 40.3495 5.80005 28.5795 4.32005 13.5195H3.12006L4.43005 22.5895L11.7601 33.8495L23.2101 40.9395L34.06 42.2795L43.8801 39.7295L57.66 26.7195L61.4 13.5395H59.7001L59.68 13.5195Z" />
	</SvgIcon>

}

export const Glass3Icon = (props) => {
	return <SvgIcon  viewBox="0 0 76 65" {...props} >
		<path d="M72.83 0.5H2.78998V4.5H72.83V0.5Z"/>
		<path d="M71.38 0.77L61.79 61H14.2L4.62 0.77V0.5H0.619995V1.08L10.79 65H65.2L75.38 1.08V0.5H71.38V0.77Z" />
		<path d="M14.64 38.3008L17.62 57.0008H58.38L61.35 38.3008H14.64Z"/>
	</SvgIcon>

}

export const Glass4Icon = (props) => {
	return <SvgIcon  viewBox="0 0 42 84" {...props} >
		<path d="M20.9999 54.3398V81.9998"  stroke-width="4" stroke-miterlimit="10"/>
		<path d="M36.79 82H5.20996"  stroke-width="4" stroke-miterlimit="10"/>
		<path d="M9.30994 27.4698C8.67994 29.5998 8.08997 31.6098 8.08997 33.0898C8.08997 42.3598 13.1599 48.3398 20.9999 48.3398C28.8399 48.3398 33.91 42.3498 33.91 33.0898C33.91 31.6198 33.3199 29.5998 32.6899 27.4698C31.9599 25.0098 31.16 22.2698 30.89 19.2598H11.1099C10.8399 22.2698 10.0399 25.0098 9.30994 27.4698Z" />
		<path d="M38.29 25.27L36.1299 19.25H34.91C35.18 21.76 35.88 24.16 36.52 26.33C37.23 28.75 37.91 31.03 37.91 33.08C37.91 44.6 31.1099 52.33 20.9999 52.33C10.8899 52.33 4.08997 44.59 4.08997 33.08C4.08997 31.03 4.75992 28.75 5.47992 26.33C6.11992 24.16 6.81997 21.76 7.08997 19.25H5.20996L2.28998 30.81L3.44995 41.62L9.03998 50.02C9.03998 50.02 17.89 54.1 18.27 54.14C18.66 54.19 24.84 53.95 24.84 53.95L28.9999 52.58L34.3699 48.67L38.97 40.29L39.9199 33.07L38.3099 25.26L38.29 25.27Z" />
		<path d="M20.9999 56.3292C8.68994 56.3292 0.0899658 46.7692 0.0899658 33.0792C0.0899658 30.4492 0.879954 27.7792 1.63995 25.1992C2.40995 22.5892 3.20996 19.8792 3.20996 17.2092V0.949219H38.79V17.2092C38.79 19.8792 39.5899 22.5792 40.3599 25.1992C41.1199 27.7792 41.91 30.4492 41.91 33.0792C41.91 46.7692 33.3099 56.3292 20.9999 56.3292ZM7.20996 4.94922V17.2092C7.20996 20.4592 6.32992 23.4392 5.47992 26.3292C4.76992 28.7492 4.08997 31.0292 4.08997 33.0792C4.08997 44.4092 11.0399 52.3292 20.9999 52.3292C30.9599 52.3292 37.91 44.4092 37.91 33.0792C37.91 31.0292 37.24 28.7492 36.52 26.3292C35.67 23.4392 34.79 20.4592 34.79 17.2092V4.94922H7.20996Z" />

	</SvgIcon>
}


export const Glass5Icon = (props) => {
	return <SvgIcon  viewBox="0 0 82 78" {...props} >
		<path d="M40.9949 40.7697L0.694946 0.429688H81.305L41.0049 40.7697H40.9949ZM10.345 4.42969L40.9949 35.1097L71.645 4.42969H10.345Z" />
		<path d="M40.9949 37.9395V75.9995"  stroke-width="4" stroke-miterlimit="10"/>
		<path d="M64.7349 76H17.2549"  stroke-width="4" stroke-miterlimit="10"/>
		<path d="M25.205 13.6504L40.9949 29.4504L56.785 13.6504H25.205Z" />
	</SvgIcon>
}

export const Glass6Icon = (props) => {
	return <SvgIcon viewBox="0 0 68 93" {...props} >
		<path d="M0.875 0.00976562V28.4398L11.045 92.3498H56.955L67.125 28.4398V0.00976562H0.875ZM63.135 28.1298L53.545 88.3598H14.465L4.875 28.1298V4.00977H63.135V28.1298Z" />
		<path d="M50.135 84.3598L59.135 28.1298V8.00977H8.875V28.1298L17.875 84.3598H50.135ZM29.305 28.3198C29.805 27.4598 30.505 26.7898 31.405 26.2998C32.305 25.8098 33.335 25.5698 34.485 25.5698C36.245 25.5698 37.605 25.9898 38.585 26.8398C39.565 27.6898 40.045 28.8798 40.045 30.4098C40.045 31.2498 39.825 32.1098 39.385 32.9898C38.945 33.8698 38.195 34.8798 37.135 36.0498L33.255 40.1398H40.595V42.8698H28.895V40.5498L34.415 34.6698C35.175 33.8398 35.735 33.1198 36.095 32.4998C36.455 31.8798 36.635 31.2998 36.635 30.7398C36.635 29.9798 36.445 29.3898 36.065 28.9498C35.685 28.5098 35.135 28.2998 34.425 28.2998C33.655 28.2998 33.055 28.5598 32.615 29.0898C32.175 29.6198 31.955 30.3098 31.955 31.1698H28.555C28.555 30.1298 28.805 29.1798 29.295 28.3198H29.305Z" />

	</SvgIcon>
}

export const Glass7Icon = (props) => {
	return <SvgIcon viewBox="0 0 68 93" {...props} >
		<path d="M0.87999 0.660156V29.0902L11.05 93.0002H56.96L67.13 29.0902V0.660156H0.869995H0.87999ZM63.14 28.7802L53.55 89.0101H14.46L4.87 28.7802V4.66016H63.13V28.7802H63.14Z" />
		<path d="M50.14 85.0101L59.14 28.7802V8.66016H8.88V28.7802L17.88 85.0101H50.14ZM34.15 36.1302H32.36V33.4802H34.16C35.02 33.4802 35.66 33.2702 36.07 32.8402C36.48 32.4102 36.69 31.8402 36.69 31.1302C36.69 30.4202 36.48 29.9102 36.07 29.5202C35.66 29.1302 35.1 28.9502 34.38 28.9502C33.73 28.9502 33.19 29.1302 32.75 29.4802C32.31 29.8302 32.09 30.3002 32.09 30.8702H28.7C28.7 29.9802 28.94 29.1802 29.42 28.4702C29.9 27.7602 30.57 27.2102 31.44 26.8102C32.31 26.4102 33.25 26.2102 34.29 26.2102C36.09 26.2102 37.51 26.6402 38.53 27.5002C39.55 28.3602 40.07 29.5502 40.07 31.0702C40.07 31.8502 39.83 32.5702 39.36 33.2302C38.89 33.8902 38.26 34.3902 37.48 34.7402C38.44 35.0802 39.16 35.6002 39.63 36.2902C40.1 36.9802 40.34 37.7902 40.34 38.7302C40.34 40.2502 39.79 41.4602 38.68 42.3702C37.57 43.2802 36.11 43.7402 34.29 43.7402C32.59 43.7402 31.19 43.2902 30.11 42.3902C29.03 41.4902 28.49 40.3002 28.49 38.8302H31.88C31.88 39.4702 32.12 39.9902 32.6 40.4002C33.08 40.8102 33.67 41.0102 34.38 41.0102C35.18 41.0102 35.82 40.8002 36.27 40.3702C36.72 39.9402 36.96 39.3802 36.96 38.6802C36.96 36.9802 36.02 36.1302 34.15 36.1302Z" />
	</SvgIcon>
}

export const Glass8Icon = (props) => {
	return <SvgIcon viewBox="0 0 52 128" {...props} >
		<path d="M40.27 45.8406L37.12 0.390625H14.87L11.71 45.8306C4.68002 50.5806 0.52002 58.4006 0.52002 66.9306V128.001H51.48V66.9306C51.48 58.3906 47.31 50.5806 40.28 45.8306L40.27 45.8406ZM47.47 124.011H4.51003V66.9406C4.51003 59.4506 8.31002 52.6206 14.68 48.6706L15.55 48.1306L18.59 4.39062H33.38L36.41 48.1306L37.28 48.6706C43.66 52.6206 47.46 59.4506 47.46 66.9406V124.011H47.47Z" />
		<path d="M35.19 52.0702L32.58 50.4502L31.03 28.0602C27.96 28.0302 24.22 28.0102 20.98 28.0202L19.42 50.4502L16.81 52.0702C11.62 55.2802 8.53003 60.8402 8.53003 66.9402V120.01H43.49V66.9402C43.49 60.8502 40.39 55.2902 35.2 52.0702H35.19ZM18.89 94.2002H15.5V81.1502L11.46 82.4002V79.6502L18.53 77.1202H18.89V94.2102V94.2002ZM26.84 93.8302C26.48 94.1602 26.02 94.3302 25.46 94.3302C24.9 94.3302 24.45 94.1602 24.09 93.8302C23.73 93.5002 23.55 93.0702 23.55 92.5402C23.55 92.0102 23.73 91.5602 24.09 91.2302C24.45 90.9002 24.91 90.7302 25.46 90.7302C26.01 90.7302 26.47 90.9002 26.84 91.2302C27.21 91.5602 27.38 92.0002 27.38 92.5402C27.38 93.0802 27.2 93.5002 26.84 93.8302ZM35.41 82.9802C37.03 82.9802 38.31 83.4802 39.23 84.4902C40.15 85.5002 40.61 86.9102 40.61 88.7202C40.61 89.8202 40.38 90.8102 39.91 91.6802C39.44 92.5502 38.78 93.2302 37.91 93.7102C37.04 94.1902 36.02 94.4302 34.84 94.4302C33.81 94.4302 32.85 94.2202 31.97 93.8002C31.09 93.3802 30.39 92.7902 29.88 92.0402C29.37 91.2902 29.1 90.4202 29.07 89.4502H32.42C32.49 90.1602 32.74 90.7102 33.16 91.1102C33.58 91.5102 34.14 91.7002 34.83 91.7002C35.6 91.7002 36.19 91.4202 36.6 90.8702C37.01 90.3202 37.22 89.5402 37.22 88.5302C37.22 87.5202 36.98 86.8202 36.51 86.3002C36.04 85.7802 35.36 85.5302 34.48 85.5302C33.68 85.5302 33.02 85.7402 32.52 86.1602L32.19 86.4602L29.49 85.7902L30.47 77.1202H40.03V79.9402H33.24L32.82 83.6102C33.62 83.1802 34.48 82.9702 35.39 82.9702L35.41 82.9802Z" />

	</SvgIcon>
}

export const Glass9Icon = (props) => {
	return <SvgIcon viewBox="0 0 54 108" {...props} >
		<path d="M45.265 107.99H8.74496L6.74496 105.99V103.04H2.35498L0.35498 101.04V17.4401L0.584961 16.5101L5.37497 7.41008L3.00497 3.64008L4.69498 0.580078H49.305L50.995 3.64008L48.625 7.41008L53.415 16.5101L53.645 17.4401V101.05L51.645 103.05H47.255V106L45.255 108L45.265 107.99ZM10.745 103.99H43.265V101.04L45.265 99.0401H49.655V17.9301L44.555 8.24008L44.635 6.24008L45.695 4.56008H8.32498L9.38498 6.24008L9.46497 8.24008L4.36496 17.9301V99.0401H8.75497L10.755 101.04V103.99H10.745Z" />
		<path d="M20.395 88.7815H21.975V86.2715L21.875 86.4315L20.395 88.7815Z" />
		<path d="M27.325 85.3909C26.995 85.3909 26.745 85.5209 26.595 85.7709C26.445 86.0209 26.355 86.4309 26.345 86.9709V88.7009C26.345 89.2809 26.425 89.7109 26.585 89.9909C26.745 90.2709 26.995 90.4109 27.345 90.4109C27.695 90.4109 27.935 90.2809 28.095 90.0009C28.255 89.7209 28.325 89.3209 28.335 88.7609V87.0709C28.335 86.4809 28.255 86.0509 28.095 85.7809C27.935 85.5109 27.685 85.3809 27.345 85.3809L27.325 85.3909Z" />
		<path d="M14.665 88.7815H16.235V86.2715L16.145 86.4315L14.665 88.7815Z" />
		<path d="M40.765 9.63055L40.805 8.56055H13.195L13.235 9.63055L8.34497 18.9205V95.0405H9.56497L14.515 99.9905H39.475L44.425 95.0405H45.645V18.9205L40.755 9.63055H40.765ZM21.695 37.8305C22.195 36.9705 22.895 36.3005 23.795 35.8105C24.695 35.3205 25.725 35.0805 26.875 35.0805C28.635 35.0805 29.995 35.5005 30.975 36.3505C31.955 37.2005 32.435 38.3905 32.435 39.9205C32.435 40.7605 32.215 41.6205 31.775 42.5005C31.335 43.3805 30.585 44.3905 29.525 45.5605L25.645 49.6505H32.985V52.3805H21.285V50.0605L26.805 44.1805C27.565 43.3505 28.125 42.6305 28.485 42.0105C28.845 41.3905 29.025 40.8105 29.025 40.2505C29.025 39.4905 28.835 38.9005 28.455 38.4605C28.075 38.0205 27.525 37.8105 26.815 37.8105C26.045 37.8105 25.445 38.0705 25.005 38.6005C24.565 39.1305 24.345 39.8205 24.345 40.6805H20.945C20.945 39.6405 21.195 38.6905 21.685 37.8305H21.695ZM18.455 89.9106H17.645V91.4505H16.235V89.9106H13.315L13.255 89.0206L16.215 84.3405H17.645V88.7706H18.455V89.9106ZM24.195 89.9106H23.385V91.4505H21.975V89.9106H19.055L18.995 89.0206L21.955 84.3405H23.385V88.7706H24.195V89.9106ZM29.735 88.5105C29.735 89.4905 29.535 90.2506 29.125 90.7706C28.715 91.2906 28.125 91.5506 27.335 91.5506C26.545 91.5506 25.965 91.3005 25.555 90.7805C25.145 90.2705 24.935 89.5406 24.925 88.5806V87.2706C24.925 86.2806 25.135 85.5205 25.545 85.0105C25.955 84.5005 26.545 84.2405 27.325 84.2405C28.105 84.2405 28.695 84.4905 29.105 85.0005C29.515 85.5106 29.725 86.2406 29.735 87.1906V88.5005V88.5105ZM38.315 91.4505H36.895V88.0806C36.895 87.7805 36.835 87.5605 36.715 87.4205C36.595 87.2805 36.395 87.2105 36.095 87.2105C35.675 87.2105 35.375 87.4105 35.215 87.8205V91.4505H33.805V88.0905C33.805 87.7805 33.745 87.5605 33.625 87.4305C33.505 87.3005 33.295 87.2206 33.005 87.2206C32.605 87.2206 32.315 87.3905 32.135 87.7206V91.4605H30.725V86.1805H32.045L32.085 86.7706C32.455 86.3106 32.965 86.0806 33.605 86.0806C34.285 86.0806 34.755 86.3505 35.005 86.8905C35.375 86.3505 35.905 86.0806 36.595 86.0806C37.165 86.0806 37.595 86.2505 37.875 86.5806C38.155 86.9106 38.295 87.4205 38.295 88.0905V91.4605L38.315 91.4505ZM40.885 91.4505H39.465V83.9505H40.885V91.4505Z" />

	</SvgIcon>
}

export const Glass10Icon = (props) => {
	return <SvgIcon viewBox="0 0 54 108" {...props} >
		<path d="M45.265 107.99H8.74496L6.74496 105.99V103.04H2.35498L0.35498 101.04V17.4401L0.584961 16.5101L5.37497 7.41008L3.00497 3.64008L4.69498 0.580078H49.305L50.995 3.64008L48.625 7.41008L53.415 16.5101L53.645 17.4401V101.05L51.645 103.05H47.255V106L45.255 108L45.265 107.99ZM10.745 103.99H43.265V101.04L45.265 99.0401H49.655V17.9301L44.555 8.24008L44.635 6.24008L45.695 4.56008H8.32498L9.38498 6.24008L9.46497 8.24008L4.36496 17.9301V99.0401H8.75497L10.755 101.04V103.99H10.745Z" />
		<path d="M20.395 88.7815H21.975V86.2715L21.875 86.4315L20.395 88.7815Z" />
		<path d="M14.665 88.7815H16.235V86.2715L16.1451 86.4315L14.665 88.7815Z" />
		<path d="M27.325 85.3909C26.995 85.3909 26.745 85.5209 26.595 85.7709C26.435 86.0309 26.355 86.4309 26.345 86.9709V88.7009C26.345 89.2809 26.425 89.7109 26.585 89.9909C26.745 90.2709 26.995 90.4109 27.345 90.4109C27.695 90.4109 27.935 90.2809 28.095 90.0009C28.245 89.7309 28.325 89.3209 28.335 88.7609V87.0709C28.335 86.4809 28.255 86.0509 28.095 85.7809C27.935 85.5109 27.685 85.3809 27.345 85.3809L27.325 85.3909Z" />
		<path d="M27.915 39.9297L27.695 40.3197L24.145 45.9597H27.915V39.9297Z" />
		<path d="M40.765 9.63055L40.805 8.56055H13.195L13.235 9.63055L8.34497 18.9205V95.0405H9.56497L14.515 99.9905H39.475L44.425 95.0405H45.645V18.9205L40.755 9.63055H40.765ZM27.885 35.3105H31.305V45.9506H33.235V48.6805H31.305V52.3705H27.915V48.6805H20.915L20.765 46.5505L27.875 35.3105H27.885ZM18.455 89.9106H17.645V91.4505H16.235V89.9106H13.315L13.255 89.0206L16.215 84.3405H17.645V88.7706H18.455V89.9106ZM24.195 89.9106H23.385V91.4505H21.975V89.9106H19.055L18.995 89.0206L21.955 84.3405H23.385V88.7706H24.195V89.9106ZM29.735 88.5105C29.735 89.4905 29.535 90.2506 29.125 90.7706C28.715 91.2906 28.125 91.5506 27.335 91.5506C26.545 91.5506 25.965 91.3005 25.555 90.7805C25.145 90.2705 24.935 89.5406 24.925 88.5806V87.2706C24.925 86.2806 25.135 85.5205 25.545 85.0105C25.955 84.5005 26.545 84.2405 27.325 84.2405C28.105 84.2405 28.695 84.4905 29.105 85.0005C29.515 85.5106 29.725 86.2406 29.735 87.1906V88.5005V88.5105ZM38.315 91.4505H36.895V88.0806C36.895 87.7805 36.835 87.5605 36.715 87.4205C36.595 87.2805 36.395 87.2105 36.095 87.2105C35.675 87.2105 35.375 87.4105 35.215 87.8205V91.4505H33.805V88.0905C33.805 87.7805 33.745 87.5605 33.625 87.4305C33.505 87.2905 33.295 87.2206 33.005 87.2206C32.605 87.2206 32.315 87.3905 32.135 87.7206V91.4605H30.725V86.1805H32.045L32.085 86.7706C32.465 86.3106 32.965 86.0806 33.605 86.0806C34.285 86.0806 34.755 86.3505 35.005 86.8905C35.375 86.3505 35.905 86.0806 36.595 86.0806C37.165 86.0806 37.595 86.2505 37.875 86.5806C38.155 86.9106 38.295 87.4205 38.295 88.0905V91.4605L38.315 91.4505ZM40.885 91.4505H39.465V83.9505H40.885V91.4505Z" />

	</SvgIcon>
}

export const Glass11Icon = (props) => {
	return <SvgIcon viewBox="0 0 66 86" {...props} >
		<path d="M65.195 21.4402C65.195 14.0302 62.9651 6.99023 58.7451 1.08023L58.145 0.240234H7.85504L7.25507 1.08023C3.03507 6.99023 0.805054 14.0302 0.805054 21.4402C0.805054 39.4302 14.1751 54.1902 30.9951 55.2802V82.0002H17.205V86.0002H48.785V82.0002H34.9951V55.2802C51.8151 54.1902 65.1851 39.4302 65.1851 21.4402H65.195ZM33.0051 51.3602C17.4651 51.3602 4.81506 37.9402 4.81506 21.4402C4.81506 15.2202 6.58506 9.29023 9.93506 4.24023H56.0651C59.4251 9.29023 61.1851 15.2102 61.1851 21.4402C61.1851 37.9402 48.5351 51.3602 32.9951 51.3602H33.0051Z" />
		<path d="M56.325 14.5195H9.69495C9.11495 16.7495 8.82495 19.0795 8.82495 21.4395C8.82495 35.7295 19.675 47.3595 33.015 47.3595C46.355 47.3595 57.205 35.7295 57.205 21.4395C57.205 19.0795 56.905 16.7495 56.335 14.5195H56.325ZM38.985 37.6795H27.285V35.3595L32.805 29.4795C33.565 28.6495 34.125 27.9295 34.485 27.3095C34.845 26.6895 35.025 26.1095 35.025 25.5495C35.025 24.7895 34.835 24.1995 34.455 23.7595C34.075 23.3195 33.525 23.1095 32.815 23.1095C32.045 23.1095 31.445 23.3695 31.005 23.8995C30.565 24.4295 30.345 25.1195 30.345 25.9795H26.9449C26.9449 24.9395 27.195 23.9895 27.685 23.1295C28.175 22.2695 28.885 21.5995 29.785 21.1095C30.685 20.6195 31.715 20.3795 32.865 20.3795C34.625 20.3795 35.985 20.7995 36.965 21.6495C37.945 22.4995 38.425 23.6895 38.425 25.2195C38.425 26.0595 38.205 26.9195 37.765 27.7995C37.325 28.6795 36.575 29.6895 35.515 30.8595L31.6349 34.9495H38.975V37.6795H38.985Z" />

	</SvgIcon>
}
export const Glass12Icon = (props) => {
	return <SvgIcon viewBox="0 0 52 145" {...props} >
		<path d="M37.26 41.0693V0.279297H14.7401V41.0693C10.4201 43.9193 0.52002 51.6193 0.52002 62.1293V144.999H51.48V62.1393C51.48 51.6193 41.57 43.9293 37.26 41.0793V41.0693ZM47.48 140.999H4.52002V62.1393C4.52002 54.7293 11.38 47.8493 17.79 43.8693L18.7401 43.2793V4.2793H33.26V43.2793L34.21 43.8693C40.63 47.8493 47.48 54.7293 47.48 62.1393V141.009V140.999Z" />
		<path d="M25.4601 82.9102C24.7801 82.9102 24.2201 83.2202 23.7801 83.8402C23.3401 84.4602 23.1201 85.2402 23.1201 86.1802C23.1201 87.1202 23.3301 87.8702 23.7601 88.4702C24.1901 89.0702 24.7901 89.3702 25.5601 89.3702C26.1101 89.3702 26.5801 89.2302 26.9701 88.9502C27.3601 88.6702 27.6601 88.3302 27.8701 87.9302V86.5402C27.8701 85.3902 27.6501 84.5002 27.2101 83.8702C26.7701 83.2402 26.1901 82.9202 25.4501 82.9202L25.4601 82.9102Z" />
		<path d="M32.1 47.269L29.26 45.509V23.239C27.21 23.219 24.9301 23.209 22.7401 23.209V45.499L19.9 47.259C14.65 50.509 8.52002 56.359 8.52002 62.129V136.999H43.48V62.139C43.48 56.369 37.35 50.519 32.1 47.269ZM31.27 88.329C31.27 91.169 30.56 93.409 29.15 95.029C27.74 96.649 25.73 97.519 23.14 97.629H22.3101V94.819H23.0601C26.0101 94.679 27.6 93.289 27.84 90.659C26.96 91.529 25.93 91.959 24.75 91.959C23.24 91.959 22.04 91.439 21.13 90.409C20.22 89.379 19.77 87.979 19.77 86.219C19.77 85.099 20.01 84.079 20.5 83.139C20.99 82.199 21.67 81.479 22.54 80.959C23.41 80.439 24.4001 80.179 25.4901 80.179C26.5801 80.179 27.6101 80.459 28.4901 81.019C29.3701 81.579 30.04 82.389 30.53 83.449C31.02 84.509 31.26 85.709 31.27 87.069V88.319V88.329Z" />

	</SvgIcon>
}




